(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.award_instyle_2025 = function() {
	this.initialize(img.award_instyle_2025);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,359,359);


(lib.award_shape_2025 = function() {
	this.initialize(img.award_shape_2025);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,365,365);


(lib.BBCA_NEO_Aftercare_30ml_Cap = function() {
	this.initialize(img.BBCA_NEO_Aftercare_30ml_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,144,479);


(lib.BBCA_NEO_BioCream_FirmRiche_15ml_Cap = function() {
	this.initialize(img.BBCA_NEO_BioCream_FirmRiche_15ml_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,144,367);


(lib.BBCA_NEO_BioGel_Firm_15ml_Cap = function() {
	this.initialize(img.BBCA_NEO_BioGel_Firm_15ml_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,144,483);


(lib.BBCA_NEO_BioSerum_Firm_30ml_Cap = function() {
	this.initialize(img.BBCA_NEO_BioSerum_Firm_30ml_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,144,481);


(lib.BBCA_NEO_Lumiere_Firm_15ml_Cap = function() {
	this.initialize(img.BBCA_NEO_Lumiere_Firm_15ml_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,144,368);


(lib.BBCA_NEO_Lumiere_Firm_15ml_Cap_NoReflection = function() {
	this.initialize(img.BBCA_NEO_Lumiere_Firm_15ml_Cap_NoReflection);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,355,809);


(lib.BBCA_NEO_Lumiere_FirmRiche_15ml_Cap_NoReflection = function() {
	this.initialize(img.BBCA_NEO_Lumiere_FirmRiche_15ml_Cap_NoReflection);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,355,809);


(lib.BBCA_NEO_NeoFirm_Cap = function() {
	this.initialize(img.BBCA_NEO_NeoFirm_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,200,271);


(lib.BBCA_NEO_NeoTherapy_Cap = function() {
	this.initialize(img.BBCA_NEO_NeoTherapy_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,200,268);


(lib.BBCA_NEO_Reactive_30ml_Cap = function() {
	this.initialize(img.BBCA_NEO_Reactive_30ml_Cap);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,144,480);


(lib.bkgnd_black_friday = function() {
	this.initialize(img.bkgnd_black_friday);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,850,480);


(lib.countertop_black_friday = function() {
	this.initialize(img.countertop_black_friday);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1642,480);


(lib.fr1BBCA_NEO_Lumiere_Firm_15mlsmear = function() {
	this.initialize(img.fr1BBCA_NEO_Lumiere_Firm_15mlsmear);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1000,1000);


(lib.fr1BBCA_NEO_Lumiere_Firm_Riche_15mlsmear = function() {
	this.initialize(img.fr1BBCA_NEO_Lumiere_Firm_Riche_15mlsmear);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1000,1000);


(lib.shadow_blackfriday = function() {
	this.initialize(img.shadow_blackfriday);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,887,500);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.overlay_navy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#1E2944").s().p("EhCZAlgMAAAhK/MCEzAAAMAAABK/g");
	this.shape.setTransform(425,240);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.overlay_navy, new cjs.Rectangle(0,0,850,480), null);


(lib.mc_shadow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.shadow_blackfriday();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_shadow, new cjs.Rectangle(0,0,887,500), null);


(lib.mc_product_9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1_copy
	this.instance = new lib.BBCA_NEO_Lumiere_FirmRiche_15ml_Cap_NoReflection();
	this.instance.setTransform(0,6,0.4096,0.4096);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_9, new cjs.Rectangle(0,6,145.4,331.3), null);


(lib.mc_product_8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_NeoTherapy_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_8, new cjs.Rectangle(0,0,200,268), null);


(lib.mc_product_7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_Reactive_30ml_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_7, new cjs.Rectangle(0,0,144,480), null);


(lib.mc_product_6_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1_copy
	this.instance = new lib.BBCA_NEO_Lumiere_Firm_15ml_Cap_NoReflection();
	this.instance.setTransform(1,0,0.4027,0.4027);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_6_2, new cjs.Rectangle(1,0,143,325.8), null);


(lib.mc_product_6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_Lumiere_Firm_15ml_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_6, new cjs.Rectangle(0,0,144,368), null);


(lib.mc_product_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_BioSerum_Firm_30ml_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_5, new cjs.Rectangle(0,0,144,481), null);


(lib.mc_product_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_BioGel_Firm_15ml_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_4, new cjs.Rectangle(0,0,144,483), null);


(lib.mc_product_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_BioCream_FirmRiche_15ml_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_3, new cjs.Rectangle(0,0,144,367), null);


(lib.mc_product_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_Aftercare_30ml_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_2, new cjs.Rectangle(0,0,144,479), null);


(lib.mc_product_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BBCA_NEO_NeoFirm_Cap();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_1, new cjs.Rectangle(0,0,200,271), null);


(lib.mc_Lumiere_Firm_Smear = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.fr1BBCA_NEO_Lumiere_Firm_15mlsmear();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_Lumiere_Firm_Smear, new cjs.Rectangle(0,0,1000,1000), null);


(lib.mc_Lumiere_Firm_Riche_Smear = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.fr1BBCA_NEO_Lumiere_Firm_Riche_15mlsmear();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_Lumiere_Firm_Riche_Smear, new cjs.Rectangle(0,0,1000,1000), null);


(lib.mc_award_shape_skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.award_shape_2025();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_award_shape_skin, new cjs.Rectangle(0,0,365,365), null);


(lib.mc_award_inStyle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.award_instyle_2025();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_award_inStyle, new cjs.Rectangle(0,0,359,359), null);


(lib.markerB = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgEgEIAJAAIAAAJIgJAAg");
	this.shape.setTransform(0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#30C0CD").s().p("AgEAFIAAgJIAJAAIAAAJg");
	this.shape_1.setTransform(0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.markerB, new cjs.Rectangle(-1,-1,3,3), null);


(lib.btn_hit_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Azbj6MAm3AAAIAAH1Mgm3AAAg");
	this.shape.setTransform(124.4,25.125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AzbD7IAAn1MAm3AAAIAAH1g");
	this.shape_1.setTransform(124.4,25.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.btn_hit_2, new cjs.Rectangle(-1,-1,250.8,52.3), null);


(lib.btn_hit_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Azbj6MAm3AAAIAAH1Mgm3AAAg");
	this.shape.setTransform(124.4,25.125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AzbD7IAAn1MAm3AAAIAAH1g");
	this.shape_1.setTransform(124.4,25.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.btn_hit_1, new cjs.Rectangle(-1,-1,250.8,52.3), null);


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.overlay_navy();
	this.instance.setTransform(0,1,1,1,0,0,0,425,240);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("A6KAKIAAgTMA0VAAAIAAAT");
	this.shape.setTransform(-257.5,-239.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-426,-241.9,851,482.9);


(lib.Tween1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.overlay_navy();
	this.instance.setTransform(0,1,1,1,0,0,0,425,240);
	this.instance.alpha = 0.8516;

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("A6KAKIAAgTMA0VAAAIAAAT");
	this.shape.setTransform(-257.5,-239.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-426,-241.9,851,482.9);


(lib.mc_product_line = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.markerB = new lib.markerB();
	this.markerB.name = "markerB";
	this.markerB.setTransform(1357.7,172.75,1,1,0,0,0,0.5,0.5);
	this.markerB.alpha = 0;

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgEgEIAJAAIAAAJIgJAAg");
	this.shape.setTransform(497.6,491.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#30C0CD").s().p("AgEAFIAAgJIAJAAIAAAJg");
	this.shape_1.setTransform(497.6,491.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape},{t:this.markerB}]}).wait(1));

	// Layer_1
	this.instance = new lib.mc_product_8();
	this.instance.setTransform(2602.75,335,1,1,0,0,0,100,134);

	this.instance_1 = new lib.mc_product_7();
	this.instance_1.setTransform(2419.1,240,1,1,0,0,0,72,240);

	this.instance_2 = new lib.mc_product_6();
	this.instance_2.setTransform(2263.45,293,1,1,0,0,0,72,184);

	this.instance_3 = new lib.mc_product_5();
	this.instance_3.setTransform(2107.8,240.5,1,1,0,0,0,72,240.5);

	this.instance_4 = new lib.mc_product_4();
	this.instance_4.setTransform(1952.15,350.5,1,1,0,0,0,72,241.5);

	this.instance_5 = new lib.mc_product_3();
	this.instance_5.setTransform(1796.5,292.5,1,1,0,0,0,72,183.5);

	this.instance_6 = new lib.mc_product_2();
	this.instance_6.setTransform(1640.85,239.5,1,1,0,0,0,72,239.5);

	this.instance_7 = new lib.mc_product_1();
	this.instance_7.setTransform(1457.2,336.5,1,1,0,0,0,100,135.5);

	this.instance_8 = new lib.mc_product_8();
	this.instance_8.setTransform(1245.55,335,1,1,0,0,0,100,134);

	this.instance_9 = new lib.mc_product_7();
	this.instance_9.setTransform(1061.9,240,1,1,0,0,0,72,240);

	this.instance_10 = new lib.mc_product_6();
	this.instance_10.setTransform(906.25,293,1,1,0,0,0,72,184);

	this.instance_11 = new lib.mc_product_5();
	this.instance_11.setTransform(750.6,240.5,1,1,0,0,0,72,240.5);

	this.instance_12 = new lib.mc_product_4();
	this.instance_12.setTransform(594.95,350.5,1,1,0,0,0,72,241.5);

	this.instance_13 = new lib.mc_product_3();
	this.instance_13.setTransform(439.3,292.5,1,1,0,0,0,72,183.5);

	this.instance_14 = new lib.mc_product_2();
	this.instance_14.setTransform(283.65,239.5,1,1,0,0,0,72,239.5);

	this.instance_15 = new lib.mc_product_1();
	this.instance_15.setTransform(100,336.5,1,1,0,0,0,100,135.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// counter_repeat
	this.instance_16 = new lib.countertop_black_friday();
	this.instance_16.setTransform(673,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(1));

	// counter
	this.instance_17 = new lib.countertop_black_friday();
	this.instance_17.setTransform(-483,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(1));

	// counter_repeat_final
	this.instance_18 = new lib.countertop_black_friday();
	this.instance_18.setTransform(1061,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_product_line, new cjs.Rectangle(-483,0,3186,592), null);


(lib.btn_learn_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hit
	this.hit_2 = new lib.btn_hit_2();
	this.hit_2.name = "hit_2";
	this.hit_2.setTransform(142.65,25.1,1,1,0,0,0,124.4,25.1);
	this.hit_2.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.hit_2).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhPBwIAAjfICeAAIAAAPIiOAAIAABZICAAAIAAAOIiAAAIAABaICPAAIAAAPg");
	this.shape.setTransform(243.425,23.7);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("ABGBwIhHhdIhJAAIAABdIgQAAIAAjfIBdAAQApAAAWAWQARARAAAYIAAACQAAAbgSAQQgSAQgeAEIBKBfgAhKAEIBLAAQAcAAATgMQASgOABgYIAAAAQgBgXgRgNQgRgNgegBIhMAAg");
	this.shape_1.setTransform(221.4,23.7);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AhRBRQgeghAAgvIAAgBQAAguAegiQAhgjAwAAQAyAAAgAjQAfAhAAAvIAAAAQgBAwgfAhQggAjgxAAQgxAAgggjgAhEhGQgbAdAAApIAAAAQAAAqAbAdQAdAeAnAAQAqAAAbgdQAbgdAAgqIAAgBQAAgpgcgdQgcgegoAAQgpAAgbAeg");
	this.shape_2.setTransform(195.35,23.7);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("ABZBwIAAjBIhZCAIAAAAIhZiAIAADBIgQAAIAAjfIAQAAIBZCDIBaiDIAQAAIAADfg");
	this.shape_3.setTransform(167.9,23.7);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("ABRBwIiejGIAADGIgPAAIAAjfIAPAAICaDCIAAjCIAQAAIAADfg");
	this.shape_4.setTransform(131.8,23.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("ABGBwIhGhdIhJAAIAABdIgRAAIAAjfIBdAAQApAAAWAWQARARAAAYIAAACQAAAbgTAQQgRAQgeAEIBKBfgAhJAEIBKAAQAdAAARgMQAUgOgBgYIAAAAQAAgXgQgNQgSgNgegBIhLAAg");
	this.shape_5.setTransform(108.5,23.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("ABeBxIgdg/IiDAAIgcA/IgSAAIBpjhIAPAAIBoDhgAA6AjIg6iBIg7CBIB1AAg");
	this.shape_6.setTransform(83.45,23.625);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AhPBwIAAjfICeAAIAAAPIiOAAIAABZICAAAIAAAOIiAAAIAABaICPAAIAAAPg");
	this.shape_7.setTransform(60.775,23.7);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AhJBwIAAjfIAQAAIAADQICDAAIAAAPg");
	this.shape_8.setTransform(40.35,23.7);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f().s("#FFFFFF").ss(1,1,1).p("Azbj6MAm3AAAIAAH1Mgm3AAAg");
	this.shape_9.setTransform(142.65,25.125);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#1E2943").s().p("AzbD7IAAn1MAm3AAAIAAH1g");
	this.shape_10.setTransform(142.65,25.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.btn_learn_2, new cjs.Rectangle(0,-1,283.1,52.3), null);


(lib.btn_learn_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hit_area
	this.hit_1 = new lib.btn_hit_1();
	this.hit_1.name = "hit_1";
	this.hit_1.setTransform(142.65,25.1,1,1,0,0,0,124.4,25.1);
	this.hit_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.hit_1).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhPBwIAAjfICeAAIAAAPIiOAAIAABZICAAAIAAAOIiAAAIAABaICPAAIAAAPg");
	this.shape.setTransform(243.425,24.7);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("ABGBwIhHhdIhJAAIAABdIgQAAIAAjfIBdAAQApAAAWAWQARARAAAZIAAABQAAAagSASQgSAOgeAFIBKBfgAhKAEIBLAAQAcAAATgMQASgPABgXIAAAAQgBgXgRgNQgRgNgegBIhMAAg");
	this.shape_1.setTransform(221.4,24.7);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AhRBRQgeghAAgvIAAgBQAAguAegiQAhgjAwAAQAyAAAgAjQAfAhAAAvIAAAAQgBAwgfAhQggAjgxAAQgxAAgggjgAhEhHQgbAeAAApIAAAAQAAAqAbAdQAdAeAnAAQAqAAAbgdQAbgdAAgqIAAgBQAAgpgcgdQgcgegoAAQgpAAgbAdg");
	this.shape_2.setTransform(195.35,24.7);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("ABZBwIAAjBIhZB/IAAAAIhZh/IAADBIgQAAIAAjfIAQAAIBZCDIBaiDIAQAAIAADfg");
	this.shape_3.setTransform(167.9,24.7);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("ABRBwIiejGIAADGIgPAAIAAjfIAPAAICaDCIAAjCIAQAAIAADfg");
	this.shape_4.setTransform(131.8,24.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("ABGBwIhGhdIhJAAIAABdIgRAAIAAjfIBdAAQApAAAWAWQARARAAAZIAAABQAAAagTASQgRAOgeAFIBKBfgAhJAEIBKAAQAdAAARgMQAUgPgBgXIAAAAQAAgXgQgNQgSgNgegBIhLAAg");
	this.shape_5.setTransform(108.5,24.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("ABeBxIgdg/IiDAAIgcA/IgSAAIBpjhIAPAAIBoDhgAA6AjIg6iBIg7CBIB1AAg");
	this.shape_6.setTransform(83.45,24.625);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AhPBwIAAjfICeAAIAAAPIiOAAIAABZICAAAIAAAOIiAAAIAABaICPAAIAAAPg");
	this.shape_7.setTransform(60.775,24.7);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AhJBwIAAjfIAQAAIAADQICDAAIAAAPg");
	this.shape_8.setTransform(40.35,24.7);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f().s("#FFFFFF").ss(1,1,1).p("Azbj6MAm3AAAIAAH1Mgm3AAAg");
	this.shape_9.setTransform(142.65,25.125);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#1E2944").s().p("AzbD7IAAn1MAm3AAAIAAH1g");
	this.shape_10.setTransform(142.65,25.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.btn_learn_1, new cjs.Rectangle(0,-1,283.1,52.3), null);


(lib.mc_overlay_copy_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.btn_learn_2.cursor = "pointer";
		
		this.btn_learn_2.addEventListener("click", function () {
		  window.open("https://store.neocutis.com/products/lumiere-firm-riche", "_self");
		});
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_2
	this.btn_learn_2 = new lib.btn_learn_2();
	this.btn_learn_2.name = "btn_learn_2";
	this.btn_learn_2.setTransform(300,257.1,1,1,0,0,0,141.5,25.1);

	this.timeline.addTween(cjs.Tween.get(this.btn_learn_2).wait(1));

	// COPY
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgeAfIAFgHQAOALAOAAQAIAAAGgEQAGgFAAgGIAAgBQAAgGgHgEQgEgDgLgDQgNgDgFgDQgJgGAAgKQAAgKAIgGQAHgGALAAQAPAAAOAJIgEAGQgNgIgMAAQgIAAgFAEQgFAEAAAGIAAABQAAAGAHAEQAEACALADQAMAEAGADQAJAGAAAJQAAALgIAHQgIAGgMAAQgSAAgPgLg");
	this.shape.setTransform(924.525,309.425);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgYAeQgMgMAAgSIAAAAQAAgQAMgNQAMgNAQAAQASAAAPAPIgGAGQgNgNgOAAQgNAAgJAKQgKAKAAAOQAAAPAKAKQAKAKANAAQAPAAAMgNIAFAFQgOAQgTAAQgQAAgMgNg");
	this.shape_1.setTransform(916.225,309.425);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_2.setTransform(909.6,307.825);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgHAAQgJAAgGgFg");
	this.shape_3.setTransform(904.35,308.2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAKAIALAAQAQAAAMgMIAFAEQgOAQgTAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_4.setTransform(896.65,309.425);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AAbA6IAAgwQAAgLgHgIQgHgIgMAAQgLAAgIAJQgJAHAAAMIAAAvIgHAAIAAh0IAHAAIAAAzQAKgRATAAQAPAAAJAJQAJAKAAAOIAAAxg");
	this.shape_5.setTransform(887.1,307.65);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgEAxQgIgGAAgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAGAAAGgDIAAAIQgHACgGAAQgLAAgEgFg");
	this.shape_6.setTransform(878.85,308.2);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AgeAfIAFgHQAOALAOAAQAIAAAGgEQAGgFAAgGIAAgBQAAgGgHgEQgEgDgLgDQgNgDgFgDQgJgGAAgKQAAgKAIgGQAHgGALAAQAPAAAOAJIgEAGQgNgIgMAAQgIAAgFAEQgFAEAAAGIAAABQAAAGAHAEQAEACALADQAMAEAGADQAJAGAAAJQAAALgIAHQgIAGgMAAQgSAAgPgLg");
	this.shape_7.setTransform(871.825,309.425);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAQAAQARAAAKANQAKALAAASIAAADIhDAAQABAPAKAJQAIAIAMAAQAQAAAMgMIAGAEQgOAQgUAAQgQAAgLgMgAAdgDQAAgNgIgJQgHgKgOAAQgLAAgIAJQgJAJgBAOIA6AAIAAAAg");
	this.shape_8.setTransform(863.4,309.425);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AAvA4IgOgfIhBAAIgPAfIgIAAIA0hvIAHAAIA0BvgAAdASIgdhAIgdBAIA6AAg");
	this.shape_9.setTransform(852.775,307.85);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AgiApIAAgFIA5hFIg3AAIAAgHIBDAAIAAAFIg6BFIA6AAIAAAHg");
	this.shape_10.setTransform(837.275,309.425);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAHAAIAAAXQAGgLAIgHQAKgHAMABIAAAJIgBAAQgPAAgIAKQgMALAAASIAAAig");
	this.shape_11.setTransform(830.3,309.3483);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAKAIALAAQAQAAAMgMIAFAEQgNAQgUAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_12.setTransform(822.05,309.425);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AAtA4IAAhgIgtA/IAAAAIgsg/IAABgIgIAAIAAhvIAIAAIAsBBIAthBIAIAAIAABvg");
	this.shape_13.setTransform(810.4,307.9);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AgGALQAIgFAAgHIgEAAIAAgNIAJAAIAAALQAAAHgDAEQgDAFgGACg");
	this.shape_14.setTransform(796.6,313.675);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQARAAALANQAKALAAASIAAADIhDAAQABAPAKAJQAIAIAMAAQAQAAAMgMIAGAEQgPAQgTAAQgQAAgLgMgAAdgDQAAgNgIgJQgHgKgOAAQgLAAgIAJQgJAJgBAOIA6AAIAAAAg");
	this.shape_15.setTransform(790.6,309.425);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#FFFFFF").s().p("AgDA6IAAh0IAHAAIAAB0g");
	this.shape_16.setTransform(783.9,307.65);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_17.setTransform(779.95,307.825);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#FFFFFF").s().p("AgLA7IAAhKIgMAAIAAgHIAMAAIAAgIQgBgOAIgHQAFgHALAAQAGAAAGACIAAAIQgHgCgFAAQgPAAAAAUIAAAIIAbAAIAAAHIgbAAIAABKg");
	this.shape_18.setTransform(775.4,307.625);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgHgIgMAAQgLAAgIAJQgIAIAAANIAAAuIgIAAIAAhRIAIAAIAAAPQAJgRATAAQAPAAAKAKQAIAJAAAPIAAAxg");
	this.shape_19.setTransform(762.6,309.325);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_20.setTransform(752.525,309.425);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_21.setTransform(737.775,309.45);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAGAAAGgDIAAAIQgGACgIAAQgJAAgGgFg");
	this.shape_22.setTransform(730.2,308.2);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_23.setTransform(722.275,309.45);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#FFFFFF").s().p("AgvA4IAAhvIAlAAQAZAAARAQQAQAQAAAXIAAAAQAAAYgQAQQgRAQgZAAgAgnAxIAdAAQAWgBAOgOQAOgNAAgUIAAgBQAAgTgOgOQgOgPgWAAIgdAAg");
	this.shape_24.setTransform(711.95,307.9);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#FFFFFF").s().p("AgEAHIAAgNIAJAAIAAANg");
	this.shape_25.setTransform(698.825,312.825);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#FFFFFF").s().p("AAIA4IAAhmIgVAHIgCgHIAZgJIAGAAIAABvg");
	this.shape_26.setTransform(693.75,307.85);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#5FBDCA").s().p("AgqArQgRgSAAgZIAAAAQAAgYARgSQASgRAYAAQAZAAARARQASASAAAYQAAAZgSARQgRASgZAAQgYAAgSgRgAglglQgPAQAAAVIAAAAQAAAWAPAQQAPAQAWAAQAWAAAQgQQAPgQAAgWQAAgWgPgPQgQgQgWAAQgVAAgQAQgAARAdIgPgWIgOAAIAAAWIgJAAIAAg7IAZAAQAKAAAGAEQAHAGAAAIQAAANgPAEIARAYgAgMAAIAPAAQAOAAAAgLQAAgLgOAAIgPAAg");
	this.shape_27.setTransform(444.075,-61.975);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#5FBDCA").s().p("AiECRQg0g8AAhSQAAhcA3g6QA3g6BUAAQCvAAAADGIkRAAQAICKBqAQQAmAGAogQQApgRAOgeIAMAFQgKApgmAfQgxAnhIAAQhPAAg3g9gABfgTQAAhTgcgwQgZgqgkAAQglAAgcAyQgdA0AABHIC3AAIAAAAg");
	this.shape_28.setTransform(416.875,-48.575);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#5FBDCA").s().p("AiWDKIAAgMQAXgIAGgTQAGgOgBgnIAAjWQAAgXgIgLQgJgMgagJIAAgOICHgdIAABdQArhJBBgQQAjgJAZAWQAQARAAAXQAAAXgQAQQgRAQgWABQgYAAgRgQQgQgRABgVQADgMgcAPQgcASgUAkIAADEQABAnAGAQQAHASAUAHIAAAMg");
	this.shape_29.setTransform(383.35,-48.95);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#5FBDCA").s().p("AiED2Qg0g9AAhSQAAhdA3g5QA3g6BUAAQCvAAAADGIkRAAQAICKBqARQAmAFAogQQApgRAOgeIAMAFQgKApgmAfQgxAnhIAAQhPAAg3g8gAg7gpQgdAyAABHIC3AAQAAhRgcgxQgZgqgkAAQglAAgcAzgABgilIjNh0IBTgZICTCNg");
	this.shape_30.setTransform(347.175,-58.6);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#5FBDCA").s().p("AhKEhIAAgNQAXgHAGgUQAFgOAAgmIAAjWQAAgWgJgLQgIgMgbgLIAAgNICGgdIAAE4QAAAnAFAPQAIATAWAGIAAANgAgojJQgOgOAAgVQAAgWAOgPQAPgPAVAAQAVAAAPAPQAQAPAAAWQAAAVgQAOQgPAPgVAAQgVAAgPgPg");
	this.shape_31.setTransform(317.875,-57.6);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#5FBDCA").s().p("ACgDKIAAgMQAXgHAGgUQAFgOAAgmIAAiwQAAhUhGAAQgbAAgZAZQgXAXAAAZIAAAMIABCvQAAAmAGAQQAHATAWAGIAAAMIigAAIAAgMQAXgHAHgUQAFgOAAgmIAAiwQAAhUhGAAQgbAAgYAZQgWAXgCAYIAAC8QAAAmAGAQQAHASAWAHIAAAMIigAAIAAgMQAWgHAHgTQAEgOAAgnIAAjTQAAgYgIgMQgJgNgagKIAAgOICHgdIAABZQAQgmAigZQAkgZAogBQBbABAQBbQANgnAlgbQAkgaApAAQA3AAAaAcQAeAhAABJIAACzQAAAmAGAQQAHATAWAGIAAAMg");
	this.shape_32.setTransform(273.025,-48.95);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#5FBDCA").s().p("AipBMIAAi7QAAgrgFgIQgHgKgkgEIAAgNICKgQIAAEWQAABRBQAAQAZAAAWgRQAXgRAMgbIAAjMQAAgrgEgIQgGgMgfgCIAAgNICEgQIAAFIQAAAeAJAJQAHAJAcADIAAAMIhxATQgWAEAAgSIAAhKQgOAkgoAaQgpAbgqAAQhzAAAAiCg");
	this.shape_33.setTransform(216.625,-48.575);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#5FBDCA").s().p("AhLE/IAAgNQAWgGAHgUQAGgOAAgnIAAnEQAAgXgJgLQgJgMgagGIAAgNICFgcIAAIhQAAAnAHAPQAHAUAWAFIAAANg");
	this.shape_34.setTransform(186.75,-60.625);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#5FBDCA").s().p("AhrCWIAAkrIDVAAIAAAUIi/AAIAAB2ICsAAIAAAUIisAAIAAB5IDBAAIAAAUg");
	this.shape_35.setTransform(704.175,-44.45);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#5FBDCA").s().p("ABgCWIAAiMIi/AAIAACMIgXAAIAAkrIAXAAIAACLIC/AAIAAiLIAXAAIAAErg");
	this.shape_36.setTransform(672.575,-44.45);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#5FBDCA").s().p("AhbBvQgrgtAAhBIAAgBQABhAAqgtQArgtBAgBQAlAAAeAOQAYAKAaAZIgQAQQgugsg4AAQg1AAgkAnQglAmAAA5IAAAAQAAA5AlAnQAlAoA1AAQA4AAAwgwIAOAPQg1A1hCAAQg/gBgrgsg");
	this.shape_37.setTransform(641.15,-44.45);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#5FBDCA").s().p("AgKCWIAAkrIAVAAIAAErg");
	this.shape_38.setTransform(618.675,-44.45);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#5FBDCA").s().p("ABeCWIheh8IhjAAIAAB8IgXAAIAAkrIB+AAQA3gBAeAeQAWAXAAAhIAAABQAAAkgYAXQgXAUgoAGIBjCAgAhjAFIBkAAQAnABAYgSQAagTAAgfIAAgBQAAgegYgSQgWgSgpAAIhmAAg");
	this.shape_39.setTransform(598.45,-44.45);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#5FBDCA").s().p("AB3CWIAAkEIh2CtIgBAAIh4itIAAEEIgVAAIAAkrIAVAAIB4CxIB5ixIAVAAIAAErg");
	this.shape_40.setTransform(550.2,-44.45);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#5FBDCA").s().p("ABfCWIhgh8IhiAAIAAB8IgWAAIAAkrIB9AAQA3gBAeAeQAWAXABAhIAAABQAAAkgZAXQgXAUgoAGIBjCAgAhjAFIBkAAQAnABAYgSQAZgTAAgfIAAgBQAAgegWgSQgYgSgoAAIhmAAg");
	this.shape_41.setTransform(517.2,-44.45);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#5FBDCA").s().p("AgKCWIAAkrIAVAAIAAErg");
	this.shape_42.setTransform(494.625,-44.45);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#5FBDCA").s().p("AhpCWIAAkrIDTAAIAAAUIi9AAIAAB8ICqAAIAAATIiqAAIAACIg");
	this.shape_43.setTransform(475.625,-44.45);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#FFFFFF").s().p("AgIALIAAgVIAQAAIAAAVg");
	this.shape_44.setTransform(558.35,197.5);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_45.setTransform(547.475,192.025);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhuAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_46.setTransform(533,191.975);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_47.setTransform(521.525,191.871);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_48.setTransform(507.675,192.025);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIAAAFIhuAAQADAYAOAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgNAPgDAWIBgAAIAAAAg");
	this.shape_49.setTransform(485.4,191.975);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#FFFFFF").s().p("Ag9BRIAEgLQAKAFANABQALgBAHgGQAHgIAIgRIhAiDIAPAAIA2B2IAwh2IAOAAIg5CJQgJAUgKAJQgKAJgPAAQgNAAgNgHg");
	this.shape_50.setTransform(470.8,194.1);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAPANAUAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_51.setTransform(456.4,191.975);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_52.setTransform(433.45,191.975);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_53.setTransform(420.875,189.975);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_54.setTransform(408.025,192.025);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_55.setTransform(393.775,191.975);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_56.setTransform(382.975,189.375);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_57.setTransform(376.525,189.1);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAPANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_58.setTransform(365.85,191.975);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAggIAAAAQAAgdAVgUQASgTAaAAQAgAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgVAgggAAQgaAAgSgSgAgkgOQgPAOAAAaIAAABQAAAaAQAQQAPAQAUAAQAVAAAQgQQARgRAAgZIAAAAQAAgZgRgPQgQgQgVAAQgVAAgPAPg");
	this.shape_59.setTransform(349.15,189.25);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_60.setTransform(325.75,191.975);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgUgLgLQgLgNgUAAQgSAAgOAOQgNANAAAUIAABMIgNAAIAAi9IANAAIAABSQAQgbAfgBQAZABAOAPQAOAPAAAXIAABRg");
	this.shape_61.setTransform(310.225,189.1);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_62.setTransform(296.875,189.975);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_63.setTransform(277.325,191.975);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgUAAIAAgLIAUAAIAAgNQAAgXAMgMQAJgKASAAQAKAAAKADIAAAMQgMgEgIAAQgaAAAAAiIAAANIAtAAIAAALIgtAAIAAB4g");
	this.shape_64.setTransform(266.85,189.075);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQAMAAAIADIAAAMQgKgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_65.setTransform(257.45,189.075);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_66.setTransform(244.175,192.125);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#FFFFFF").s().p("AhBBZIAAiuIANAAIAAAeQAVggAggBQAaABASARQAVAUAAAfIAAABQAAAegVATQgSATgaAAQggAAgVggIAABHgAgkg8QgRARAAAZIAAAAQAAAYARAQQAQAQAUAAQAXAAAOgPQAPgQAAgZIAAAAQAAgZgQgRQgOgPgWgBQgUAAgQAQg");
	this.shape_67.setTransform(228.2,193.9);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#FFFFFF").s().p("AgiAHIAAgNIBFAAIAAANg");
	this.shape_68.setTransform(213.9,190.875);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAQAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_69.setTransform(201.15,191.975);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAggIAAAAQAAgdAVgUQASgTAaAAQAgAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgVAgggAAQgaAAgSgSgAgkgOQgPAOAAAaIAAABQAAAaAQAQQAPAQAUAAQAVAAAQgQQARgRAAgZIAAAAQAAgZgRgPQgQgQgVAAQgVAAgPAPg");
	this.shape_70.setTransform(184.45,189.25);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#FFFFFF").s().p("AgtBOQgUgTAAgfIAAgBQAAgeAUgTQATgTAZAAQAiAAAUAfIAAhVIANAAIAAC9IgNAAIAAgeQgVAhghgBQgZABgTgTgAgkgOQgPAPAAAZIAAABQAAAZAPARQAPAQAVAAQAVgBAQgQQARgQAAgYIAAgBQAAgZgRgPQgQgQgVAAQgWAAgOAPg");
	this.shape_71.setTransform(658.15,153.45);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_72.setTransform(642.175,156.025);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_73.setTransform(626.225,156.225);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#FFFFFF").s().p("AgLATQAOgJgBgMIgGAAIAAgWIAQAAIAAATQAAALgFAHQgFAIgKAEg");
	this.shape_74.setTransform(608.075,163.1);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_75.setTransform(598.825,156.175);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_76.setTransform(584.725,156.025);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_77.setTransform(569.2,156.175);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_78.setTransform(556.625,154.175);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAi9IANAAIAABSQAQgcAfAAQAZAAAOAPQAOAPAAAYIAABRg");
	this.shape_79.setTransform(543.675,153.3);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#FFFFFF").s().p("Ag7BFIAIgLQAYATAcAAQAYAAAOgNQAOgOAAgZIAAgTQgWAfggAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAhAAAVAeIAAgbIANAAIAABvQAAAcgRARQgSASgeAAQghAAgbgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgWAAgOAOg");
	this.shape_80.setTransform(526.6,158.125);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_81.setTransform(515.225,153.575);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_82.setTransform(507.575,156.071);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#FFFFFF").s().p("Ag0BBIAAAdIgNAAIAAi9IANAAIAABWQAVggAgAAQAaAAASASQAVAUAAAdIAAABQAAAfgVAUQgSASgaAAQggABgVgggAgkgNQgRAQAAAYIAAABQAAAYARAQQAQAQAUABQAXgBAOgPQAPgPAAgaIAAgBQAAgZgQgPQgOgQgWAAQgUAAgQAQg");
	this.shape_83.setTransform(493.45,153.45);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#FFFFFF").s().p("AgLATQAOgJgBgMIgGAAIAAgWIAQAAIAAATQAAALgFAHQgFAIgKAEg");
	this.shape_84.setTransform(473.325,163.1);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_85.setTransform(464.075,156.175);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAARATQARAUAAAdIgBAFIhtAAQADAYAPAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_86.setTransform(450.35,156.175);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#FFFFFF").s().p("Ag4BCIAAgHIBehxIhbAAIAAgLIBuAAIAAAHIheBxIBeAAIAAALg");
	this.shape_87.setTransform(435.875,156.175);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_88.setTransform(425.425,153.575);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_89.setTransform(417.775,156.071);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_90.setTransform(403.725,156.325);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_91.setTransform(390.625,154.175);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_92.setTransform(379.125,156.175);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_93.setTransform(369.625,153.575);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_94.setTransform(358.125,156.175);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#FFFFFF").s().p("ABIBbIAAidIhIBnIAAAAIhIhnIAACdIgNAAIAAi1IANAAIBIBqIBJhqIANAAIAAC1g");
	this.shape_95.setTransform(338.525,153.7);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#FFFFFF").s().p("AAKA3IAAhRIgeAAIAAgHIANgBIAIgDQAEgCADgEQADgEABgHIAJAAIAABtg");
	this.shape_96.setTransform(315.125,149.1);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#FFFFFF").s().p("AgIALIAAgVIAQAAIAAAVg");
	this.shape_97.setTransform(307.85,161.7);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_98.setTransform(298.225,156.175);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#FFFFFF").s().p("Ag9BRIAFgLQAJAGANAAQAKAAAIgIQAIgHAHgRIhAiCIAPAAIA2B1IAwh1IAOAAIg5CIQgJAUgKAJQgKAIgPAAQgNABgNgHg");
	this.shape_99.setTransform(284.8,158.3);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_100.setTransform(269.825,156.225);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#FFFFFF").s().p("AgtBOQgUgTAAgfIAAgBQAAgeAUgTQATgTAZAAQAhAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgWAhgggBQgZABgTgTgAgkgOQgPAPAAAZIAAABQAAAZAPARQAQAQAUAAQAWgBAPgQQARgQAAgYIAAgBQAAgZgRgPQgPgQgWAAQgWAAgOAPg");
	this.shape_101.setTransform(253.8,153.45);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#FFFFFF").s().p("AAeBcIAAgtIhhAAIgFgKIBniAIAMAAIAAB/IAeAAIAAALIgeAAIAAAtgAg4AkIBWAAIAAhrg");
	this.shape_102.setTransform(229.15,153.625);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#FFFFFF").s().p("AANBcIAAioIgiALIgEgKIApgQIAKAAIAAC3g");
	this.shape_103.setTransform(215.275,153.625);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_104.setTransform(197.475,156.175);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_105.setTransform(183.325,156.225);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_106.setTransform(739.075,121.025);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_107.setTransform(722.725,121.175);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_108.setTransform(706.125,121.175);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_109.setTransform(691.175,121.175);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_110.setTransform(670.475,121.175);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_111.setTransform(656.325,121.225);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_112.setTransform(633.675,121.025);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_113.setTransform(622.375,118.575);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_114.setTransform(604.725,121.175);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_115.setTransform(592.075,121.175);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANATAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_116.setTransform(578.35,121.175);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_117.setTransform(562.825,121.025);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#FFFFFF").s().p("AApBfIg0hBIggAhIAAAgIgNAAIAAi9IANAAIAACNIBRhTIARAAIg5A5IA7BKg");
	this.shape_118.setTransform(548.275,118.3);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_119.setTransform(535.775,121.071);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_120.setTransform(521.925,121.225);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAgfIAAgBQAAgeAVgUQASgSAZAAQAhAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgWAhgggBQgZABgSgTgAgkgOQgPAPAAAaIAAAAQAAAaAQAQQAPAQAUAAQAWgBAPgQQARgQAAgYIAAgBQAAgZgRgPQgPgQgWAAQgWAAgOAPg");
	this.shape_121.setTransform(505.9,118.45);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANATAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_122.setTransform(482.5,121.175);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#FFFFFF").s().p("Ag9BSIAEgMQALAGAMAAQAKAAAIgIQAIgGAHgSIhAiCIAPAAIA2B1IAwh1IAOAAIg6CHQgIAVgKAJQgKAIgPAAQgNAAgNgFg");
	this.shape_123.setTransform(467.9,123.3);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAARATQARAUAAAdIgBAFIhtAAQADAYAPAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_124.setTransform(453.5,121.175);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#FFFFFF").s().p("AgiAHIAAgNIBFAAIAAANg");
	this.shape_125.setTransform(440.5,120.075);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_126.setTransform(430.775,121.071);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhuAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_127.setTransform(417.35,121.175);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#FFFFFF").s().p("AgtBOQgUgTAAgfIAAgBQAAgeAUgUQATgSAaAAQAhAAAUAfIAAhVIANAAIAAC9IgNAAIAAgeQgWAhgfgBQgaABgTgTgAgkgOQgPAPAAAaIAAAAQAAAaAPAQQAPAQAVAAQAVgBAQgQQARgQAAgYIAAgBQAAgZgRgPQgQgQgVAAQgVAAgPAPg");
	this.shape_128.setTransform(400.65,118.45);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_129.setTransform(384.675,121.025);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_130.setTransform(368.525,121.325);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAgfIAAgBQAAgeAVgUQASgSAZAAQAhAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgWAhgggBQgZABgSgTgAgkgOQgPAPAAAaIAAAAQAAAaAQAQQAPAQAUAAQAWgBAPgQQARgQAAgYIAAgBQAAgZgRgPQgPgQgWAAQgWAAgOAPg");
	this.shape_131.setTransform(343.9,118.45);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_132.setTransform(327.925,121.025);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_133.setTransform(311.975,121.225);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#FFFFFF").s().p("AgLATQAOgJgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_134.setTransform(293.825,128.1);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_135.setTransform(284.575,121.175);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_136.setTransform(271.925,121.175);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAARATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_137.setTransform(258.2,121.175);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_138.setTransform(242.675,121.025);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_139.setTransform(231.375,118.575);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgUAAIAAgLIAUAAIAAgNQAAgXAMgMQAJgKARAAQAMAAAIADIAAAMQgKgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_140.setTransform(223.95,118.275);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgUAAIAAgLIAUAAIAAgNQAAgXALgMQAKgKASAAQAKAAAKADIAAAMQgMgEgIAAQgaAAAAAiIAAANIAtAAIAAALIgtAAIAAB4g");
	this.shape_141.setTransform(214.55,118.275);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_142.setTransform(201.275,121.325);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#FFFFFF").s().p("AhBBYIAAisIANAAIAAAdQAWghAgAAQAZAAASASQAVAUAAAfIAAAAQAAAegVAVQgSASgZAAQghAAgVggIAABGgAgkg7QgRAQAAAYIAAABQAAAXARARQAQAQAUAAQAXAAAOgPQAPgPAAgaIAAgBQAAgZgQgQQgPgPgVAAQgUgBgQARg");
	this.shape_143.setTransform(185.3,123.1);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#FFFFFF").s().p("AgLASQAOgIgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_144.setTransform(743.975,93.1);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_145.setTransform(734.725,86.175);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAPANATAAQAaAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_146.setTransform(721,86.175);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_147.setTransform(710.075,83.3);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#FFFFFF").s().p("AApBfIg0hBIggAhIAAAgIgNAAIAAi9IANAAIAACNIBRhTIARAAIg5A5IA7BKg");
	this.shape_148.setTransform(700.375,83.3);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_149.setTransform(684.475,86.025);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_150.setTransform(673.175,83.575);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_151.setTransform(665.525,86.071);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#FFFFFF").s().p("AAoBDIgohxIgnBxIgKAAIgxiEIAOAAIAoBzIAoh0IAKAAIAoB0IAohzIANAAIgwCEg");
	this.shape_152.setTransform(648.375,86.2);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#FFFFFF").s().p("AgLASQAOgIgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_153.setTransform(626.075,93.1);

	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_154.setTransform(616.825,86.175);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANATAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_155.setTransform(603.1,86.175);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_156.setTransform(587.575,86.025);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_157.setTransform(576.275,83.575);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_158.setTransform(569.825,83.3);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANATAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_159.setTransform(551.35,86.175);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_160.setTransform(535.825,86.025);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_161.setTransform(524.525,83.575);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQAMAAAIADIAAAMQgKgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_162.setTransform(517.1,83.275);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQAMAAAIADIAAAMQgKgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_163.setTransform(499.9,83.275);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_164.setTransform(486.425,86.175);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_165.setTransform(462.85,86.175);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_166.setTransform(448.275,86.175);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_167.setTransform(432.875,86.025);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_168.setTransform(416.925,86.225);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_169.setTransform(406.125,86.071);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_170.setTransform(392.275,86.225);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_171.setTransform(377.8,86.175);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#FFFFFF").s().p("AhBBYIAAisIANAAIAAAdQAVghAgABQAagBASATQAVATAAAfIAAAAQAAAfgVAUQgSASgaAAQggAAgVggIAABGgAgkg7QgRAQAAAYIAAABQAAAYARAQQAQAQAUAAQAXAAAOgPQAPgPAAgaIAAgBQAAgZgQgQQgOgPgWAAQgUgBgQARg");
	this.shape_172.setTransform(361.95,88.1);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#FFFFFF").s().p("AhBBYIAAisIANAAIAAAdQAVghAhABQAZgBATATQAUATAAAfIAAAAQAAAfgUAUQgTASgZAAQghAAgVggIAABGgAgkg7QgRAQAAAYIAAABQAAAYARAQQAPAQAWAAQAVAAAPgPQAPgPAAgaIAAgBQAAgZgPgQQgQgPgUAAQgWgBgPARg");
	this.shape_173.setTransform(344.8,88.1);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_174.setTransform(327.925,86.225);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAPANAUAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_175.setTransform(305.65,86.175);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_176.setTransform(290.125,83.3);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_177.setTransform(276.775,84.175);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAARATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_178.setTransform(256.4,86.175);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_179.setTransform(241.825,86.175);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_180.setTransform(226.175,86.325);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAgfIAAgBQAAgdAVgVQASgSAZAAQAhAAAVAgIAAhXIANAAIAAC9IgNAAIAAgdQgWAhgggBQgZABgSgTgAgkgOQgPAPAAAaIAAAAQAAAaAQAQQAPAPAUAAQAWABAPgRQARgQAAgYIAAgBQAAgZgRgQQgPgPgWAAQgWAAgOAPg");
	this.shape_181.setTransform(209.35,83.45);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_182.setTransform(193.75,86.175);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_183.setTransform(182.275,86.071);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#FFFFFF").s().p("AhBBYIAAitIANAAIAAAeQAWghAgABQAZgBASATQAVATAAAfIAAAAQAAAfgVATQgSATgZAAQghAAgVgfIAABFgAgkg7QgRAQAAAYIAAABQAAAYARAQQAQAQAUAAQAXAAAOgPQAPgQAAgZIAAgBQAAgZgQgQQgPgQgVABQgUAAgQAQg");
	this.shape_184.setTransform(682.55,53.1);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_185.setTransform(670.325,48.3);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhtAAQABAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_186.setTransform(659.65,51.175);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_187.setTransform(644.125,48.3);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_188.setTransform(619.975,51.175);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_189.setTransform(606.775,49.175);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#FFFFFF").s().p("AgsBPQgVgVAAgeIAAgBQAAgdAVgVQASgSAaAAQAhAAAUAgIAAhXIANAAIAAC9IgNAAIAAgdQgVAhggAAQgaAAgSgSgAgkgOQgPAPAAAaIAAAAQAAAaAQAQQAPAPAUAAQAVABAQgRQARgQAAgYIAAgBQAAgZgRgQQgQgPgVAAQgVAAgPAPg");
	this.shape_190.setTransform(584.85,48.45);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAPANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_191.setTransform(569.25,51.175);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_192.setTransform(556.675,49.175);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_193.setTransform(543.825,51.225);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_194.setTransform(533.575,48.3);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_195.setTransform(522.275,51.325);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_196.setTransform(502.175,51.025);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_197.setTransform(485.325,51.071);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_198.setTransform(471.075,51.175);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQALAAAKADIAAAMQgLgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_199.setTransform(458.8,48.275);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_200.setTransform(433.525,51.025);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_201.setTransform(413.225,51.225);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_202.setTransform(398.75,51.175);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_203.setTransform(387.275,51.071);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_204.setTransform(374.075,51.175);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_205.setTransform(351.25,51.175);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#FFFFFF").s().p("Ag9BSIAFgLQAJAEANAAQAKABAIgIQAHgHAIgRIhAiDIAPAAIA2B2IAwh2IAOAAIg5CIQgJAVgKAJQgKAJgPgBQgNAAgNgFg");
	this.shape_206.setTransform(336.65,53.3);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_207.setTransform(322.25,51.175);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#FFFFFF").s().p("Ag7BFIAHgLQAZATAcAAQAYAAANgNQAPgOAAgZIAAgTQgVAfghAAQgZAAgTgRQgUgSAAgaIAAgBQAAgcAUgSQATgRAZAAQAiAAAUAeIAAgbIANAAIAABvQAAAcgRARQgSASgeAAQggAAgcgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgVAAgPAOg");
	this.shape_208.setTransform(297.75,53.125);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_209.setTransform(281.775,51.025);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_210.setTransform(270.475,48.575);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_211.setTransform(259.425,51.025);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAQAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_212.setTransform(243.9,51.175);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_213.setTransform(231.325,49.175);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_214.setTransform(218.375,48.3);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#FFFFFF").s().p("Ag7BFIAHgLQAZATAcAAQAYAAANgNQAPgOAAgZIAAgTQgVAfghAAQgZAAgTgRQgUgSAAgaIAAgBQAAgcAUgSQATgRAZAAQAhAAAVAeIAAgbIANAAIAABvQAAAcgRARQgRASgfAAQghAAgbgUgAgkg+QgPAOAAAWIAAABQAAAWAPAOQAPAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgVAAgPAOg");
	this.shape_215.setTransform(201.3,53.125);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_216.setTransform(189.925,48.575);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_217.setTransform(181.425,49.175);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#FFFFFF").s().p("AgsBPQgVgVAAgfIAAAAQAAgdAVgVQASgSAaAAQAhAAAUAgIAAhXIANAAIAAC9IgNAAIAAgdQgWAhgfAAQgaAAgSgSgAgkgOQgPAOAAAbIAAAAQAAAZAQARQAPAPAUAAQAWAAAPgPQARgRAAgZIAAAAQAAgZgRgQQgPgPgWAAQgVAAgPAPg");
	this.shape_218.setTransform(666.2,13.45);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_219.setTransform(650.225,16.025);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_220.setTransform(634.275,16.225);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#FFFFFF").s().p("AgLASQAOgHgBgNIgGAAIAAgWIAQAAIAAATQAAALgFAIQgFAGgKAFg");
	this.shape_221.setTransform(616.125,23.1);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#FFFFFF").s().p("Ag7BFIAHgLQAZATAcAAQAYAAANgNQAPgOAAgZIAAgTQgVAfghAAQgZAAgTgRQgUgSAAgaIAAgBQAAgcAUgSQATgRAZAAQAhAAAVAeIAAgbIANAAIAABvQAAAcgRARQgRASgfAAQghAAgbgUgAgkg+QgPAOAAAWIAAABQAAAWAPAOQAPAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgVAAgPAOg");
	this.shape_222.setTransform(604.5,18.125);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_223.setTransform(588.525,16.025);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_224.setTransform(577.225,13.575);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_225.setTransform(568.725,14.175);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_226.setTransform(555.875,16.225);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_227.setTransform(541.025,16.025);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_228.setTransform(529.725,13.575);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_229.setTransform(514.225,16.025);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_230.setTransform(493.725,16.325);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_231.setTransform(482.675,13.3);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_232.setTransform(476.225,13.3);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_233.setTransform(469.775,13.575);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#FFFFFF").s().p("AgLASQAOgHgBgNIgGAAIAAgWIAQAAIAAATQAAALgFAIQgFAGgKAFg");
	this.shape_234.setTransform(455.425,23.1);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#FFFFFF").s().p("Ag7BFIAIgLQAYATAcAAQAYAAAOgNQAOgOAAgZIAAgTQgWAfggAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAhAAAVAeIAAgbIANAAIAABvQAAAcgRARQgSASgeAAQggAAgcgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgWAAgOAOg");
	this.shape_235.setTransform(443.8,18.125);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_236.setTransform(427.825,16.025);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_237.setTransform(416.525,13.575);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#FFFFFF").s().p("Ag4BCIAAgHIBehxIhbAAIAAgLIBuAAIAAAHIheBxIBeAAIAAALg");
	this.shape_238.setTransform(406.125,16.175);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_239.setTransform(395.675,13.575);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_240.setTransform(388.025,16.071);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_241.setTransform(373.975,16.325);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_242.setTransform(360.875,14.175);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_243.setTransform(349.375,16.175);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_244.setTransform(339.875,13.575);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_245.setTransform(328.375,16.175);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_246.setTransform(307.775,16.025);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#FFFFFF").s().p("AgiAHIAAgNIBFAAIAAANg");
	this.shape_247.setTransform(290.05,15.075);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_248.setTransform(276.875,16.225);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_249.setTransform(266.075,16.071);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_250.setTransform(254.825,14.175);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#FFFFFF").s().p("AAvBCIgvg7IguA7IgPAAIA2hCIg0hBIAQAAIArA4IAtg4IAPAAIg0BAIA3BDg");
	this.shape_251.setTransform(242.3,16.175);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_252.setTransform(228.2,16.175);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_253.setTransform(204.875,16.025);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#FFFFFF").s().p("ABMBcIgXgzIhqAAIgXAzIgOAAIBUi3IAMAAIBVC3gAAwAdIgwhpIgvBpIBfAAg");
	this.shape_254.setTransform(186.575,13.625);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_overlay_copy_2, new cjs.Rectangle(158.5,-93.9,772.1,412.6), null);


(lib.mc_overlay_copy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.btn_learn_1.cursor = "pointer";
		
		this.btn_learn_1.addEventListener("click", function () {
		  window.open("https://store.neocutis.com/products/lumiere-firm", "_self");
		});
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_2
	this.btn_learn_1 = new lib.btn_learn_1();
	this.btn_learn_1.name = "btn_learn_1";
	this.btn_learn_1.setTransform(300,226.1,1,1,0,0,0,141.5,25.1);

	this.timeline.addTween(cjs.Tween.get(this.btn_learn_1).wait(1));

	// COPY
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgDA4IAAhoIgnAAIAAgHIBVAAIAAAHIgnAAIAABog");
	this.shape.setTransform(776.475,312.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AAkA4IAAg0IhHAAIAAA0IgIAAIAAhvIAIAAIAAA0IBHAAIAAg0IAIAAIAABvg");
	this.shape_1.setTransform(765.225,312.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgiApQgPgQAAgYIAAgBQAAgXAPgRQAQgRAXAAQAXAAASAPIgFAGQgQgOgUABQgTAAgOAPQgMAOAAAUIAAAAQAAAWAMAOQAOAOAVAAQAUAAAPgMIAAghIglAAIAAgGIAtAAIAAAqQgTARgZAAQgYAAgQgRg");
	this.shape_2.setTransform(752.825,312.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgDA4IAAhvIAHAAIAABvg");
	this.shape_3.setTransform(744.475,312.4);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AAoA4IhOhiIAABiIgIAAIAAhvIAIAAIBNBgIAAhgIAIAAIAABvg");
	this.shape_4.setTransform(736.025,312.4);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgoAoQgQgQAAgXIAAgBQAAgXAQgRQARgRAXAAQAZAAAQARQAQARAAAXIAAAAQAAAYgQAQQgQASgZAAQgYAAgQgSgAghgiQgNAOgBAUIAAAAQAAAVAOAPQANAPAUgBQAUAAAOgOQAOgPAAgUIAAgBQAAgUgOgOQgOgPgUAAQgUAAgNAPg");
	this.shape_5.setTransform(718.1,312.4);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AAjA4IgjguIgkAAIAAAuIgJAAIAAhvIAuAAQAVAAALALQAIAIAAANQAAANgJAJQgJAHgOACIAlAwgAgkACIAkAAQAPAAAJgGQAJgGAAgNIAAAAQAAgLgIgGQgJgIgPAAIglAAg");
	this.shape_6.setTransform(705.975,312.4);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AghApQgQgRAAgXIAAgBQAAgXAQgRQAQgRAXAAQAOAAALAFQAJAEAJAJIgFAGQgSgQgUAAQgTgBgOAPQgNAOAAAVIAAAAQAAAVANAPQAOAOATAAQAVAAASgRIAFAGQgUATgYAAQgXAAgQgRg");
	this.shape_7.setTransform(694.125,312.4);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgDA4IAAhvIAHAAIAABvg");
	this.shape_8.setTransform(685.775,312.4);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AAsA4IAAhgIgsA/IAAAAIgsg/IAABgIgIAAIAAhvIAIAAIAsBBIAthBIAIAAIAABvg");
	this.shape_9.setTransform(676.7,312.4);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgGgIgNAAQgLAAgIAJQgJAIAAANIAAAuIgHAAIAAhRIAHAAIAAAPQALgRASAAQAQAAAIAKQAJAJAAAPIAAAxg");
	this.shape_10.setTransform(660.15,313.825);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_11.setTransform(653.2,312.325);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AgeAfIAFgHQAOALAOAAQAIAAAGgEQAGgFAAgGIAAgBQAAgGgHgEQgEgDgLgDQgNgDgFgDQgJgGAAgKQAAgKAIgGQAHgGALAAQAPAAAOAJIgEAGQgNgIgMAAQgIAAgFAEQgFAEAAAGIAAABQAAAGAHAEQAEACALADQAMAEAGADQAJAGAAAJQAAALgIAHQgIAGgMAAQgSAAgPgLg");
	this.shape_12.setTransform(642.325,313.925);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAQAAQARAAAKANQAKALAAASIAAADIhDAAQABAPAKAJQAIAIAMAAQAQAAAMgMIAGAEQgOAQgUAAQgQAAgLgMgAAdgDQAAgNgIgJQgHgKgOAAQgLAAgIAJQgJAJgBAOIA6AAIAAAAg");
	this.shape_13.setTransform(633.9,313.925);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AgbAwQgMgMAAgTIAAAAQAAgTAMgMQAMgLAPAAQAUAAANATIAAg1IAIAAIAAB0IgIAAIAAgSQgNAVgUAAQgPAAgMgMgAgVgIQgKAJAAAQQAAAPAKALQAJAJAMAAQAOAAAJgKQAKgKAAgPIAAAAQAAgPgKgKQgJgJgOAAQgMgBgJAKg");
	this.shape_14.setTransform(623.6,312.25);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_15.setTransform(616.65,312.325);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgGAAQgKAAgGgFg");
	this.shape_16.setTransform(611.4,312.7);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#FFFFFF").s().p("AgnA3IAAhqIAHAAIAAASQANgVAUABQAPAAAMALQANAMAAATQAAASgNANQgMALgPAAQgUAAgNgTIAAArgAgWgkQgKAKAAAPIAAAAQAAAOAKALQAKAJAMAAQAOAAAJgJQAJgJAAgQIAAAAQAAgPgJgLQgKgJgNAAQgMAAgKAKg");
	this.shape_17.setTransform(603.25,315.1);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQARAAALANQAKALAAASIAAADIhDAAQABAPAKAJQAJAIALAAQAQAAAMgMIAGAEQgPAQgTAAQgQAAgLgMgAAdgDQgBgNgHgJQgHgKgOAAQgLAAgIAJQgJAJgBAOIA6AAIAAAAg");
	this.shape_18.setTransform(593.15,313.925);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#FFFFFF").s().p("AgoA4IAAhvIAoAAQASAAAMAJQALAKAAAPQAAARgNAJQgMAJgSAAIgeAAIAAAqgAggAGIAfAAQAPABAJgHQAKgIAAgMIAAgBQAAgMgKgHQgJgIgOAAIggAAg");
	this.shape_19.setTransform(583.575,312.4);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#FFFFFF").s().p("AglAyIADgHQAFAEAJAAQAFAAAGgFQAEgEAFgLIgohQIAJAAIAhBIIAehIIAIAAIgjBUQgFAMgGAGQgGAFgJAAQgJAAgHgEg");
	this.shape_20.setTransform(568.3,315.225);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAHAAIAAAXQAFgLAJgHQAKgHAMABIAAAJIgBAAQgPAAgJAKQgLALAAASIAAAig");
	this.shape_21.setTransform(560.9,313.8483);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_22.setTransform(552.375,313.95);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgHAAQgJAAgGgFg");
	this.shape_23.setTransform(544.8,312.7);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAKAIALAAQAQAAAMgMIAFAEQgOAQgTAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_24.setTransform(537.1,313.925);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_25.setTransform(530.4,312.325);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAHAAIAAAXQAFgLAJgHQAKgHAMABIAAAJIgBAAQgPAAgJAKQgLALAAASIAAAig");
	this.shape_26.setTransform(525.7,313.8483);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#FFFFFF").s().p("AgoA3IAAhqIAIAAIAAASQANgVAUABQAQAAALALQAMAMAAATQAAASgMANQgLALgQAAQgUAAgNgTIAAArgAgWgkQgKAKAAAPIAAAAQAAAOAKALQAKAJAMAAQAOAAAIgJQAKgJAAgQIAAAAQAAgPgKgLQgIgJgOAAQgMAAgKAKg");
	this.shape_27.setTransform(517,315.1);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_28.setTransform(506.375,313.925);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAIAAIAAAXQAEgLAJgHQAKgHAMABIAAAJIgBAAQgPAAgIAKQgMALABASIAAAig");
	this.shape_29.setTransform(498.95,313.8483);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#FFFFFF").s().p("AgoA4IAAhvIAoAAQASAAAMAJQALAKAAAPQAAARgNAJQgMAJgSAAIgeAAIAAAqgAggAGIAfAAQAPABAJgHQAKgIAAgMIAAgBQAAgMgKgHQgJgIgOAAIggAAg");
	this.shape_30.setTransform(490.375,312.4);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#FFFFFF").s().p("AgLA7IAAhKIgMAAIAAgHIAMAAIAAgIQAAgOAHgHQAGgHAKAAQAHAAAFACIAAAIQgGgCgGAAQgPAAAAAUIAAAIIAbAAIAAAHIgbAAIAABKg");
	this.shape_31.setTransform(477.25,312.125);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_32.setTransform(468.975,313.925);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#FFFFFF").s().p("AgFAxQgGgGAAgLIAAg0IgMAAIAAgHIAMAAIAAgaIAHAAIAAAaIAcAAIAAAHIgcAAIAAAzQABAQAPAAQAGAAAGgDIAAAIQgGACgIAAQgKAAgFgFg");
	this.shape_33.setTransform(455.8,312.7);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgGgIgNAAQgLAAgIAJQgJAIABANIAAAuIgIAAIAAhRIAIAAIAAAPQAJgRATAAQAPAAAKAKQAIAJAAAPIAAAxg");
	this.shape_34.setTransform(447.85,313.825);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#FFFFFF").s().p("AgZAgQgJgJAAgPIAAgxIAIAAIAAAwQAAAMAHAIQAHAHAMAAQALAAAIgIQAIgIAAgNIAAguIAIAAIAABRIgIAAIAAgPQgKARgSAAQgQAAgIgKg");
	this.shape_35.setTransform(437.875,314.025);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_36.setTransform(427.975,313.925);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#FFFFFF").s().p("AA2AqIAAgwQAAgNgHgHQgGgIgLAAQgLAAgIAIQgHAIAAANIAAAvIgHAAIAAgwQAAgNgGgHQgHgIgKAAQgLAAgIAJQgIAIAAANIAAAuIgIAAIAAhRIAIAAIAAAPQALgRAQAAQATAAAIASQAKgSATAAQAPAAAJAKQAHAJABAPIAAAxg");
	this.shape_37.setTransform(415.3,313.825);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_38.setTransform(402.825,313.95);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAJAIAMAAQAQAAAMgMIAFAEQgNAQgUAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_39.setTransform(389.15,313.925);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgHgIgMAAQgLAAgIAJQgJAIAAANIAAAuIgHAAIAAhRIAHAAIAAAPQALgRASAAQAQAAAIAKQAJAJAAAPIAAAxg");
	this.shape_40.setTransform(379.6,313.825);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_41.setTransform(372.65,312.325);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#FFFFFF").s().p("AgDA6IAAh0IAHAAIAAB0g");
	this.shape_42.setTransform(368.7,312.15);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAJAIAMAAQAQAAAMgMIAFAEQgNAQgUAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_43.setTransform(362.15,313.925);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#FFFFFF").s().p("AgeAfIAFgHQAOALAOAAQAIAAAGgEQAGgFAAgGIAAgBQAAgGgHgEQgEgDgLgDQgNgDgFgDQgJgGAAgKQAAgKAIgGQAHgGALAAQAPAAAOAJIgEAGQgNgIgMAAQgIAAgFAEQgFAEAAAGIAAABQAAAGAHAEQAEACALADQAMAEAGADQAJAGAAAJQAAALgIAHQgIAGgMAAQgSAAgPgLg");
	this.shape_44.setTransform(353.325,313.925);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_45.setTransform(344.625,313.95);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#FFFFFF").s().p("AggAoIAAARIgHAAIAAh0IAHAAIAAA2QANgUAUAAQAQAAALALQANAMAAATQAAASgNANQgLAMgQAAQgUgBgNgTgAgWgIQgKAKAAAPIAAAAQAAAPAKALQAKAJAMAAQAOAAAJgJQAJgKAAgQIAAAAQAAgQgJgJQgJgJgOAAQgMgBgKAKg");
	this.shape_46.setTransform(335.3,312.25);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAQAAQAQAAALANQAKALAAASIAAADIhDAAQABAPAJAJQAJAIAMAAQAQAAAMgMIAFAEQgNAQgUAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_47.setTransform(320.4,313.925);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#FFFFFF").s().p("AAbA6IAAgwQAAgLgHgIQgGgIgNAAQgLAAgIAJQgJAHAAAMIAAAvIgHAAIAAh0IAHAAIAAAzQALgRASAAQAQAAAIAJQAJAKAAAOIAAAxg");
	this.shape_48.setTransform(310.85,312.15);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgGAAQgKAAgGgFg");
	this.shape_49.setTransform(302.6,312.7);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_50.setTransform(289.575,313.925);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgGAAQgKAAgGgFg");
	this.shape_51.setTransform(281.45,312.7);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#FFFFFF").s().p("AgbAwQgNgMAAgTIAAAAQAAgTANgMQALgLAQAAQAUAAANATIAAg1IAHAAIAAB0IgHAAIAAgSQgOAVgTAAQgQAAgLgMgAgWgIQgJAJAAAQQAAAPAJALQAKAJAMAAQANAAAKgKQALgKgBgPIAAAAQABgPgLgKQgKgJgNAAQgMgBgKAKg");
	this.shape_52.setTransform(267.95,312.25);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAQAAQAQAAALANQAKALAAASIAAADIhDAAQABAPAJAJQAJAIAMAAQAQAAAMgMIAGAEQgOAQgUAAQgQAAgLgMgAAegDQgBgNgIgJQgIgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_53.setTransform(258.4,313.925);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAIAAIAAAXQAEgLAJgHQAKgHAMABIAAAJIgBAAQgPAAgIAKQgLALAAASIAAAig");
	this.shape_54.setTransform(251.35,313.8483);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_55.setTransform(242.825,313.95);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#FFFFFF").s().p("AgoA3IAAhqIAIAAIAAASQANgVAUABQAQAAALALQAMAMAAATQAAASgMANQgLALgQAAQgUAAgNgTIAAArgAgWgkQgKAKAAAPIAAAAQAAAOAKALQAKAJAMAAQAOAAAIgJQAKgJAAgQIAAAAQAAgPgKgLQgIgJgOAAQgMAAgKAKg");
	this.shape_56.setTransform(233.5,315.1);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#FFFFFF").s().p("AA2AqIAAgwQAAgNgGgHQgHgIgLAAQgLAAgHAIQgIAIAAANIAAAvIgHAAIAAgwQAAgNgHgHQgFgIgMAAQgKAAgIAJQgIAIAAANIAAAuIgHAAIAAhRIAHAAIAAAPQALgRAQAAQATAAAIASQAKgSAUAAQAOAAAIAKQAJAJgBAPIAAAxg");
	this.shape_57.setTransform(220.4,313.825);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_58.setTransform(207.675,313.925);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#FFFFFF").s().p("AghApQgQgRAAgXIAAgBQAAgXAQgRQAQgRAXAAQAOAAALAFQAJAEAJAJIgFAGQgSgQgUAAQgTgBgOAPQgNAOAAAVIAAAAQAAAVANAPQAOAOATAAQAVAAASgRIAFAGQgUATgYAAQgXAAgQgRg");
	this.shape_59.setTransform(197.125,312.4);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#FFFFFF").s().p("AgDAYIACgVIgRAMIgDgGIASgJIgSgIIADgGIARAMIgCgVIAGAAIgBAVIARgMIAEAGIgTAIIATAJIgEAGIgRgMIABAVg");
	this.shape_60.setTransform(187.55,309.125);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#FFFFFF").s().p("AgCAYIABgVIgRAMIgDgGIATgJIgTgIIADgGIARAMIgBgVIAFAAIgBAVIARgMIAEAGIgTAIIATAJIgEAGIgRgMIABAVg");
	this.shape_61.setTransform(180.7,309.125);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#FFFFFF").s().p("AAtA4IAAhgIgtA/IAAAAIgsg/IAABgIgIAAIAAhvIAIAAIAsBBIAthBIAIAAIAABvg");
	this.shape_62.setTransform(711.05,294.4);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#FFFFFF").s().p("AAvA4IgOgfIhBAAIgPAfIgIAAIA0hvIAHAAIA0BvgAAdASIgdhAIgdBAIA6AAg");
	this.shape_63.setTransform(697.825,294.35);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#FFFFFF").s().p("AgnA4IAAhvIBPAAIAAAHIhHAAIAAAsIA/AAIAAAIIg/AAIAAAtIBHAAIAAAHg");
	this.shape_64.setTransform(686.475,294.4);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#FFFFFF").s().p("AAjA4IgjguIgkAAIAAAuIgJAAIAAhvIAuAAQAVAAALALQAIAIAAANQAAANgJAJQgJAHgOACIAlAwgAgkACIAkAAQAPAAAJgGQAJgGAAgNIAAAAQAAgLgIgGQgJgIgPAAIglAAg");
	this.shape_65.setTransform(675.475,294.4);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#FFFFFF").s().p("AghApQgQgRAAgXIAAgBQAAgXAQgRQAQgRAXAAQAOAAALAFQAJAEAJAJIgFAGQgSgQgUAAQgTgBgOAPQgNAOAAAVIAAAAQAAAVANAPQAOAOATAAQAVAAASgRIAFAGQgUATgYAAQgXAAgQgRg");
	this.shape_66.setTransform(663.625,294.4);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#FFFFFF").s().p("AgoAoQgQgQAAgXIAAgBQAAgXAQgRQAQgRAYAAQAZAAAQARQAQARAAAXIAAAAQAAAYgQAQQgRASgYAAQgYAAgQgSgAghgiQgOAOAAAUIAAAAQAAAVAOAPQAOAPATgBQAVAAANgOQANgPABgUIAAgBQAAgUgOgOQgNgPgVAAQgTAAgOAPg");
	this.shape_67.setTransform(645.85,294.4);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#FFFFFF").s().p("AgDA4IAAhvIAHAAIAABvg");
	this.shape_68.setTransform(636.875,294.4);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#FFFFFF").s().p("AgsA4IAAhvIAuAAQATAAAKAKQAHAHAAAKIAAABQAAASgTAIQAaAGgBAUIAAAAQABAOgLAJQgMAIgRAAgAgjAxIAoAAQAOgBAIgGQAJgGAAgLIAAAAQAAgKgJgGQgJgFgQAAIglAAgAgjgEIAkAAQANAAAIgFQAHgHAAgKQAAgKgGgFQgIgHgOAAIgkAAg");
	this.shape_69.setTransform(629.25,294.4);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgGgIgNAAQgLAAgIAJQgJAIABANIAAAuIgIAAIAAhRIAIAAIAAAPQAJgRATAAQAQAAAJAKQAIAJAAAPIAAAxg");
	this.shape_70.setTransform(613.55,295.825);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_71.setTransform(606.6,294.325);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#FFFFFF").s().p("AgeAfIAFgHQAOALAOAAQAIAAAGgEQAGgFAAgGIAAgBQAAgGgHgEQgEgDgLgDQgNgDgFgDQgJgGAAgKQAAgKAIgGQAHgGALAAQAPAAAOAJIgEAGQgNgIgMAAQgIAAgFAEQgFAEAAAGIAAABQAAAGAHAEQAEACALADQAMAEAGADQAJAGAAAJQAAALgIAHQgIAGgMAAQgSAAgPgLg");
	this.shape_72.setTransform(595.725,295.925);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAIAAIAAAXQAEgLAJgHQAKgHAMABIAAAJIgBAAQgPAAgJAKQgLALABASIAAAig");
	this.shape_73.setTransform(589.15,295.8483);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_74.setTransform(580.375,295.925);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAGAAAGgDIAAAIQgHACgHAAQgJAAgGgFg");
	this.shape_75.setTransform(572.25,294.7);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#FFFFFF").s().p("AgYAeQgMgMAAgSIAAAAQAAgQAMgNQAMgNAQAAQASAAAPAPIgGAGQgNgNgOAAQgNAAgJAKQgKAKAAAOQAAAPAKAKQAKAKANAAQAPAAAMgNIAFAFQgOAQgTAAQgQAAgMgNg");
	this.shape_76.setTransform(564.675,295.925);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_77.setTransform(555.175,295.95);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#FFFFFF").s().p("AgnA4IAAhvIBOAAIAAAHIhFAAIAAAuIA+AAIAAAHIg+AAIAAAzg");
	this.shape_78.setTransform(546.4,294.4);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#FFFFFF").s().p("AAbA6IAAgwQAAgLgHgIQgHgIgMAAQgLAAgIAJQgJAHABAMIAAAvIgIAAIAAh0IAIAAIAAAzQAJgRATAAQAQAAAJAJQAIAKAAAOIAAAxg");
	this.shape_79.setTransform(531.2,294.15);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#FFFFFF").s().p("AgFAxQgGgGAAgLIAAg0IgMAAIAAgHIAMAAIAAgaIAIAAIAAAaIAbAAIAAAHIgbAAIAAAzQAAAQAPAAQAFAAAHgDIAAAIQgGACgIAAQgKAAgFgFg");
	this.shape_80.setTransform(522.95,294.7);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#FFFFFF").s().p("AAZApIgZhFIgYBFIgHAAIgdhRIAIAAIAaBHIAYhHIAFAAIAZBHIAZhHIAIAAIgeBRg");
	this.shape_81.setTransform(512.95,295.925);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_82.setTransform(501.375,295.925);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAHAAIAAAXQAGgLAIgHQAKgHAMABIAAAJIgBAAQgPAAgJAKQgKALgBASIAAAig");
	this.shape_83.setTransform(493.95,295.8483);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#FFFFFF").s().p("AgiApQgPgQAAgYIAAgBQAAgXAPgRQAQgRAXAAQAXAAASAPIgFAGQgQgOgUABQgTAAgOAPQgMAOAAAUIAAAAQAAAWAMAOQAOAOAVAAQAUAAAPgMIAAghIglAAIAAgGIAtAAIAAAqQgTARgZAAQgYAAgQgRg");
	this.shape_84.setTransform(483.925,294.4);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#FFFFFF").s().p("AgLA7IAAhKIgMAAIAAgHIAMAAIAAgIQAAgOAHgHQAGgHAKAAQAGAAAGACIAAAIQgHgCgFAAQgPAAAAAUIAAAIIAbAAIAAAHIgbAAIAABKg");
	this.shape_85.setTransform(470.4,294.125);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_86.setTransform(462.125,295.925);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#FFFFFF").s().p("AgFAxQgGgGgBgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgHAAQgJAAgGgFg");
	this.shape_87.setTransform(448.95,294.7);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgGgIgNAAQgLAAgIAJQgJAIAAANIAAAuIgHAAIAAhRIAHAAIAAAPQALgRASAAQAQAAAIAKQAJAJAAAPIAAAxg");
	this.shape_88.setTransform(441,295.825);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#FFFFFF").s().p("AgZAgQgJgJAAgPIAAgxIAIAAIAAAwQAAAMAHAIQAHAHAMAAQALAAAIgIQAIgIAAgNIAAguIAIAAIAABRIgIAAIAAgPQgKARgSAAQgQAAgIgKg");
	this.shape_89.setTransform(431.025,296.025);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_90.setTransform(421.125,295.925);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#FFFFFF").s().p("AA2AqIAAgwQAAgNgHgHQgGgIgLAAQgLAAgIAIQgHAIAAANIAAAvIgHAAIAAgwQAAgNgGgHQgHgIgKAAQgLAAgIAJQgIAIAAANIAAAuIgIAAIAAhRIAIAAIAAAPQALgRARAAQASAAAIASQAKgSATAAQAPAAAJAKQAHAJABAPIAAAxg");
	this.shape_91.setTransform(408.45,295.825);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_92.setTransform(395.975,295.95);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAKAIALAAQAQAAAMgMIAFAEQgOAQgTAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_93.setTransform(382.3,295.925);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#FFFFFF").s().p("AAbAqIAAgwQAAgMgHgIQgHgIgMAAQgLAAgIAJQgJAIAAANIAAAuIgHAAIAAhRIAHAAIAAAPQAKgRATAAQAPAAAJAKQAJAJAAAPIAAAxg");
	this.shape_94.setTransform(372.75,295.825);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#FFFFFF").s().p("AgDA5IAAhRIAHAAIAABRgAgEgtIAAgLIAJAAIAAALg");
	this.shape_95.setTransform(365.8,294.325);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#FFFFFF").s().p("AgDA6IAAh0IAHAAIAAB0g");
	this.shape_96.setTransform(361.85,294.15);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAKAIALAAQAQAAAMgMIAFAEQgOAQgTAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_97.setTransform(355.3,295.925);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#FFFFFF").s().p("AgeAfIAFgHQAOALAOAAQAIAAAGgEQAGgFAAgGIAAgBQAAgGgHgEQgEgDgLgDQgNgDgFgDQgJgGAAgKQAAgKAIgGQAHgGALAAQAPAAAOAJIgEAGQgNgIgMAAQgIAAgFAEQgFAEAAAGIAAABQAAAGAHAEQAEACALADQAMAEAGADQAJAGAAAJQAAALgIAHQgIAGgMAAQgSAAgPgLg");
	this.shape_98.setTransform(346.475,295.925);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_99.setTransform(337.775,295.95);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#FFFFFF").s().p("AggAoIAAARIgIAAIAAh0IAIAAIAAA2QANgUAUAAQAQAAALALQAMAMAAATQAAASgMANQgLAMgQAAQgUgBgNgTgAgWgIQgKAKAAAPIAAAAQAAAPAKALQAKAJAMAAQAOAAAIgJQAKgKAAgQIAAAAQAAgQgKgJQgIgJgOAAQgMgBgKAKg");
	this.shape_100.setTransform(328.45,294.25);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAPAAQASAAAKANQAKALAAASIAAADIhDAAQABAPAJAJQAKAIALAAQAQAAAMgMIAFAEQgNAQgUAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_101.setTransform(313.55,295.925);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#FFFFFF").s().p("AAbA6IAAgwQAAgLgHgIQgGgIgNAAQgLAAgIAJQgJAHAAAMIAAAvIgHAAIAAh0IAHAAIAAAzQALgRASAAQAQAAAIAJQAJAKAAAOIAAAxg");
	this.shape_102.setTransform(304,294.15);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#FFFFFF").s().p("AgFAxQgHgGAAgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgGAAQgLAAgFgFg");
	this.shape_103.setTransform(295.75,294.7);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_104.setTransform(282.725,295.925);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#FFFFFF").s().p("AgFAxQgHgGAAgLIAAg0IgLAAIAAgHIALAAIAAgaIAIAAIAAAaIAcAAIAAAHIgcAAIAAAzQAAAQAQAAQAFAAAHgDIAAAIQgHACgGAAQgLAAgFgFg");
	this.shape_105.setTransform(274.6,294.7);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#FFFFFF").s().p("AgbAwQgNgMAAgTIAAAAQAAgTANgMQALgLAQAAQAUAAANATIAAg1IAHAAIAAB0IgHAAIAAgSQgOAVgTAAQgQAAgLgMgAgWgIQgJAJAAAQQAAAPAJALQAKAJAMAAQANAAAKgKQAKgKAAgPIAAAAQAAgPgKgKQgKgJgNAAQgMgBgKAKg");
	this.shape_106.setTransform(261.1,294.25);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#FFFFFF").s().p("AgZAfQgMgMAAgTIAAAAQAAgRALgMQALgNAQAAQAQAAALANQAKALAAASIAAADIhDAAQABAPAJAJQAJAIAMAAQAQAAAMgMIAFAEQgNAQgUAAQgQAAgLgMgAAegDQgCgNgGgJQgJgKgNAAQgLAAgJAJQgIAJgBAOIA7AAIAAAAg");
	this.shape_107.setTransform(251.55,295.925);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#FFFFFF").s().p("AgVAqIAAhRIAIAAIAAAXQAEgLAJgHQAKgHAMABIAAAJIgBAAQgPAAgIAKQgLALAAASIAAAig");
	this.shape_108.setTransform(244.5,295.8483);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#FFFFFF").s().p("AgYAkQgKgHAAgMIAAAAQAAgNAKgGQAJgHAQAAQANAAAOADIAAgDQAAgMgHgGQgHgHgNAAQgMAAgNAHIgDgHQAPgIANAAQARAAAJAJQAIAJAAAPIAAAxIgHAAIAAgNQgLAPgUABQgMAAgJgHgAgTACQgHAFAAAJIAAABQAAAIAHAFQAHAFAKAAQAMAAAJgHQAJgHAAgLIAAgJQgPgDgNAAQgMAAgHAEg");
	this.shape_109.setTransform(235.975,295.95);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#FFFFFF").s().p("AgoA3IAAhqIAIAAIAAASQAOgVATABQAQAAALALQAMAMAAATQAAASgMANQgLALgQAAQgUAAgNgTIAAArgAgWgkQgKAKAAAPIAAAAQAAAOAKALQAKAJAMAAQAOAAAIgJQAKgJAAgQIAAAAQAAgPgKgLQgIgJgOAAQgMAAgKAKg");
	this.shape_110.setTransform(226.65,297.1);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#FFFFFF").s().p("AA2AqIAAgwQAAgNgGgHQgHgIgLAAQgLAAgHAIQgIAIAAANIAAAvIgHAAIAAgwQAAgNgHgHQgFgIgMAAQgLAAgHAJQgIAIAAANIAAAuIgIAAIAAhRIAIAAIAAAPQALgRAQAAQAUAAAHASQAKgSAUAAQAOAAAIAKQAJAJgBAPIAAAxg");
	this.shape_111.setTransform(213.55,295.825);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#FFFFFF").s().p("AgdAeQgMgMAAgSIAAAAQAAgRAMgMQAMgNARAAQASAAAMANQAMAMAAARQAAARgMANQgMANgSAAQgRAAgMgNgAgXgYQgKAKAAAOQAAAPAKAKQAKAKANAAQAOAAAKgKQAJgKAAgPIAAAAQAAgOgJgKQgKgKgOAAQgOAAgJAKg");
	this.shape_112.setTransform(200.825,295.925);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#FFFFFF").s().p("AghApQgQgRAAgXIAAgBQAAgXAQgRQAQgRAXAAQAOAAALAFQAJAEAJAJIgFAGQgSgQgUAAQgTgBgOAPQgNAOAAAVIAAAAQAAAVANAPQAOAOATAAQAVAAASgRIAFAGQgUATgYAAQgXAAgQgRg");
	this.shape_113.setTransform(190.275,294.4);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#FFFFFF").s().p("AgCAYIABgVIgRAMIgDgGIATgJIgTgIIADgGIARAMIgBgVIAFAAIgBAVIARgMIAEAGIgTAIIATAJIgEAGIgRgMIABAVg");
	this.shape_114.setTransform(180.7,291.125);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#5FBDCA").s().p("AgqArQgRgSAAgZIAAAAQAAgYARgSQASgRAYAAQAZAAARARQASASAAAYQAAAZgSARQgRASgZAAQgYAAgSgRgAglglQgPAQAAAVIAAAAQAAAWAPAQQAPAQAWAAQAWAAAQgQQAPgQAAgWQAAgWgPgPQgQgQgWAAQgVAAgQAQgAARAdIgPgWIgOAAIAAAWIgJAAIAAg7IAZAAQAKAAAGAEQAHAGAAAIQAAANgPAEIARAYgAgMAAIAPAAQAOAAAAgLQAAgLgOAAIgPAAg");
	this.shape_115.setTransform(444.075,-61.975);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#5FBDCA").s().p("AiECRQg0g8AAhSQAAhcA3g6QA3g6BUAAQCvAAAADGIkRAAQAICKBqAQQAmAGAogQQApgRAOgeIAMAFQgKApgmAfQgxAnhIAAQhPAAg3g9gABfgTQAAhTgcgwQgZgqgkAAQglAAgcAyQgdA0AABHIC3AAIAAAAg");
	this.shape_116.setTransform(416.875,-48.575);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#5FBDCA").s().p("AiWDKIAAgMQAXgIAGgTQAGgOgBgnIAAjWQAAgXgIgLQgJgMgagJIAAgOICHgdIAABdQArhJBBgQQAjgJAZAWQAQARAAAXQAAAXgQAQQgRAQgWABQgYAAgRgQQgQgRABgVQADgMgcAPQgcASgUAkIAADEQABAnAGAQQAHASAUAHIAAAMg");
	this.shape_117.setTransform(383.35,-48.95);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#5FBDCA").s().p("AiED2Qg0g9AAhSQAAhdA3g5QA3g6BUAAQCvAAAADGIkRAAQAICKBqARQAmAFAogQQApgRAOgeIAMAFQgKApgmAfQgxAnhIAAQhPAAg3g8gAg7gpQgdAyAABHIC3AAQAAhRgcgxQgZgqgkAAQglAAgcAzgABgilIjNh0IBTgZICTCNg");
	this.shape_118.setTransform(347.175,-58.6);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#5FBDCA").s().p("AhKEhIAAgNQAXgHAGgUQAFgOAAgmIAAjWQAAgWgJgLQgIgMgbgLIAAgNICGgdIAAE4QAAAnAFAPQAIATAWAGIAAANgAgojJQgOgOAAgVQAAgWAOgPQAPgPAVAAQAVAAAPAPQAQAPAAAWQAAAVgQAOQgPAPgVAAQgVAAgPgPg");
	this.shape_119.setTransform(317.875,-57.6);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#5FBDCA").s().p("ACgDKIAAgMQAXgHAGgUQAFgOAAgmIAAiwQAAhUhGAAQgbAAgZAZQgXAXAAAZIAAAMIABCvQAAAmAGAQQAHATAWAGIAAAMIigAAIAAgMQAXgHAHgUQAFgOAAgmIAAiwQAAhUhGAAQgbAAgYAZQgWAXgCAYIAAC8QAAAmAGAQQAHASAWAHIAAAMIigAAIAAgMQAWgHAHgTQAEgOAAgnIAAjTQAAgYgIgMQgJgNgagKIAAgOICHgdIAABZQAQgmAigZQAkgZAogBQBbABAQBbQANgnAlgbQAkgaApAAQA3AAAaAcQAeAhAABJIAACzQAAAmAGAQQAHATAWAGIAAAMg");
	this.shape_120.setTransform(273.025,-48.95);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#5FBDCA").s().p("AipBMIAAi7QAAgrgFgIQgHgKgkgEIAAgNICKgQIAAEWQAABRBQAAQAZAAAWgRQAXgRAMgbIAAjMQAAgrgEgIQgGgMgfgCIAAgNICEgQIAAFIQAAAeAJAJQAHAJAcADIAAAMIhxATQgWAEAAgSIAAhKQgOAkgoAaQgpAbgqAAQhzAAAAiCg");
	this.shape_121.setTransform(216.625,-48.575);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#5FBDCA").s().p("AhLE/IAAgNQAWgGAHgUQAGgOAAgnIAAnEQAAgXgJgLQgJgMgagGIAAgNICFgcIAAIhQAAAnAHAPQAHAUAWAFIAAANg");
	this.shape_122.setTransform(186.75,-60.625);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#5FBDCA").s().p("AB3CWIAAkEIh2CtIgBAAIh4itIAAEEIgVAAIAAkrIAVAAIB4CxIB5ixIAVAAIAAErg");
	this.shape_123.setTransform(550.2,-44.45);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#5FBDCA").s().p("ABfCWIhgh8IhiAAIAAB8IgWAAIAAkrIB9AAQA3gBAeAeQAWAXABAhIAAABQAAAkgZAXQgXAUgoAGIBjCAgAhjAFIBkAAQAnABAYgSQAZgTAAgfIAAgBQAAgegWgSQgYgSgoAAIhmAAg");
	this.shape_124.setTransform(517.2,-44.45);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#5FBDCA").s().p("AgKCWIAAkrIAVAAIAAErg");
	this.shape_125.setTransform(494.625,-44.45);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#5FBDCA").s().p("AhpCWIAAkrIDTAAIAAAUIi9AAIAAB8ICqAAIAAATIiqAAIAACIg");
	this.shape_126.setTransform(475.625,-44.45);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#FFFFFF").s().p("AgIALIAAgVIAQAAIAAAVg");
	this.shape_127.setTransform(632.05,161.7);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_128.setTransform(622.425,156.175);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhuAAQADAYAOAPQAPANATAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgNAPgDAWIBgAAIAAAAg");
	this.shape_129.setTransform(608.7,156.175);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#FFFFFF").s().p("Ag9BRIAEgLQAKAGANAAQALAAAHgIQAHgHAIgRIhAiCIAPAAIA2B1IAwh1IAOAAIg5CIQgJAUgKAJQgKAIgPAAQgNABgNgHg");
	this.shape_130.setTransform(594.1,158.3);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_131.setTransform(579.7,156.175);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#FFFFFF").s().p("Ag7BFIAIgLQAYATAcAAQAYAAAOgNQAOgOAAgZIAAgTQgWAfggAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAhAAAVAeIAAgbIANAAIAABvQAAAcgRARQgSASgeAAQghAAgbgUgAgkg+QgPAOAAAWIAAABQAAAWAPAOQAPAOAVAAQAUAAARgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgWAAgOAOg");
	this.shape_132.setTransform(555.2,158.125);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_133.setTransform(539.225,156.025);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_134.setTransform(527.925,153.575);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#FFFFFF").s().p("AApBfIg0hBIggAhIAAAgIgNAAIAAi9IANAAIAACNIBRhTIARAAIg5A5IA7BKg");
	this.shape_135.setTransform(518.225,153.3);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_136.setTransform(501.875,156.175);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_137.setTransform(485.275,156.175);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_138.setTransform(473.725,153.3);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#FFFFFF").s().p("AgiAHIAAgNIBFAAIAAANg");
	this.shape_139.setTransform(465.2,155.075);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_140.setTransform(455.475,156.071);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAZAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_141.setTransform(442.05,156.175);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#FFFFFF").s().p("Ag7BFIAIgLQAYATAcAAQAYAAAOgNQAOgOAAgZIAAgTQgWAfggAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAhAAAVAeIAAgbIANAAIAABvQAAAcgRARQgSASgeAAQghAAgbgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgWAAgOAOg");
	this.shape_142.setTransform(425.35,158.125);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_143.setTransform(409.375,156.025);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_144.setTransform(393.225,156.325);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_145.setTransform(377.125,156.175);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#FFFFFF").s().p("Ag9BRIAEgLQAKAGANAAQALAAAHgIQAHgHAIgRIhAiCIAPAAIA2B1IAwh1IAOAAIg5CIQgJAUgKAJQgKAIgPAAQgNABgNgHg");
	this.shape_146.setTransform(361.9,158.3);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#FFFFFF").s().p("AgLATQAOgJgBgMIgGAAIAAgWIAQAAIAAATQAAALgFAHQgFAIgKAEg");
	this.shape_147.setTransform(343.175,163.1);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#FFFFFF").s().p("AgtBOQgUgTAAgfIAAgBQAAgeAUgTQATgTAZAAQAiAAAUAfIAAhVIANAAIAAC9IgNAAIAAgeQgVAhghgBQgZABgTgTgAgkgOQgPAPAAAZIAAABQAAAZAPARQAPAQAVAAQAVgBAQgQQARgQAAgYIAAgBQAAgZgRgPQgQgQgVAAQgWAAgOAPg");
	this.shape_148.setTransform(331.55,153.45);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_149.setTransform(315.95,156.175);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAi9IANAAIAABSQAQgcAfAAQAZAAAOAPQAOAPAAAYIAABRg");
	this.shape_150.setTransform(300.425,153.3);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_151.setTransform(285.725,156.175);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIAAAFIhuAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_152.setTransform(272,156.175);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_153.setTransform(260.525,156.071);

	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQALAAAKADIAAAMQgLgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_154.setTransform(250.35,153.275);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAQANATAAQAZAAAUgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_155.setTransform(237.7,156.175);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_156.setTransform(226.225,156.071);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_157.setTransform(208.025,156.071);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_158.setTransform(193.775,156.175);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQALAAAKADIAAAMQgLgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_159.setTransform(181.5,153.275);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_160.setTransform(739.575,121.175);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_161.setTransform(726.925,121.175);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_162.setTransform(713.2,121.175);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_163.setTransform(697.675,121.025);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_164.setTransform(686.375,118.575);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgUAAIAAgLIAUAAIAAgNQAAgXALgMQAKgKASAAQAKAAAKADIAAAMQgMgEgIAAQgaAAAAAiIAAANIAtAAIAAALIgtAAIAAB4g");
	this.shape_165.setTransform(678.95,118.275);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXAMgMQAJgKARAAQAMAAAIADIAAAMQgLgEgJAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_166.setTransform(669.55,118.275);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_167.setTransform(656.275,121.325);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#FFFFFF").s().p("AhBBYIAAisIANAAIAAAdQAWghAfAAQAaAAASASQAVAUAAAfIAAAAQAAAegVAVQgSASgaAAQggAAgVggIAABGgAgkg7QgRAQAAAYIAAABQAAAXARARQAPAQAVAAQAWAAAPgPQAPgPAAgaIAAgBQAAgZgPgQQgPgPgWAAQgVgBgPARg");
	this.shape_168.setTransform(640.3,123.1);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgUAAIAAgLIAUAAIAAgNQAAgXAMgMQAJgKASAAQAKAAAKADIAAAMQgMgEgIAAQgaAAAAAiIAAANIAtAAIAAALIgtAAIAAB4g");
	this.shape_169.setTransform(619.3,118.275);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_170.setTransform(605.825,121.175);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#FFFFFF").s().p("AApBfIg0hBIggAhIAAAgIgNAAIAAi9IANAAIAACNIBRhTIARAAIg5A5IA7BKg");
	this.shape_171.setTransform(583.225,118.3);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_172.setTransform(566.875,121.175);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_173.setTransform(550.275,121.175);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_174.setTransform(538.725,118.3);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_175.setTransform(520.25,121.175);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAi9IANAAIAABSQAQgcAfAAQAZAAAOAPQAOAPAAAYIAABRg");
	this.shape_176.setTransform(504.725,118.3);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_177.setTransform(491.375,119.175);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIAAAFIhuAAQADAYAOAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgNAPgDAWIBgAAIAAAAg");
	this.shape_178.setTransform(471,121.175);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_179.setTransform(456.425,121.175);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#FFFFFF").s().p("AgqA0QgOgOAAgZIAAhQIANAAIAABOQAAAVALAMQALAMAUAAQATAAANgNQANgOAAgUIAAhMIANAAIAACEIgNAAIAAgZQgQAcgfAAQgYAAgPgQg");
	this.shape_180.setTransform(440.775,121.325);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#FFFFFF").s().p("AgtBOQgUgTAAgfIAAgBQAAgeAUgUQATgSAaAAQAgAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgWAhgfgBQgaABgTgTgAgkgOQgPAPAAAaIAAAAQAAAaAPAQQAPAQAVAAQAWgBAPgQQARgQAAgYIAAgBQAAgZgRgPQgPgQgWAAQgVAAgPAPg");
	this.shape_181.setTransform(423.95,118.45);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhuAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_182.setTransform(408.35,121.175);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_183.setTransform(396.875,121.071);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#FFFFFF").s().p("AgtBOQgUgTAAgfIAAgBQAAgeAUgUQATgSAZAAQAiAAAUAfIAAhVIANAAIAAC9IgNAAIAAgeQgWAhgggBQgZABgTgTgAgkgOQgPAPAAAaIAAAAQAAAaAPAQQAPAQAVAAQAVgBAQgQQARgQAAgYIAAgBQAAgZgRgPQgQgQgVAAQgVAAgPAPg");
	this.shape_184.setTransform(374.1,118.45);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_185.setTransform(358.125,121.025);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_186.setTransform(342.175,121.225);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#FFFFFF").s().p("AgLATQAOgJgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_187.setTransform(324.025,128.1);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_188.setTransform(314.775,121.175);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAASATQAQAUAAAdIgBAFIhtAAQACAYAPAPQAPANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_189.setTransform(301.05,121.175);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_190.setTransform(290.125,118.3);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_191.setTransform(279.675,121.175);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_192.setTransform(268.325,121.071);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_193.setTransform(259.125,118.575);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_194.setTransform(248.675,121.175);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#FFFFFF").s().p("AApBfIg0hBIggAhIAAAgIgNAAIAAi9IANAAIAACNIBRhTIARAAIg5A5IA7BKg");
	this.shape_195.setTransform(226.825,118.3);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_196.setTransform(214.325,121.071);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_197.setTransform(200.475,121.225);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAgfIAAgBQAAgeAVgUQASgSAaAAQAgAAAVAfIAAhVIANAAIAAC9IgNAAIAAgeQgVAhgggBQgaABgSgTgAgkgOQgPAPAAAaIAAAAQAAAaAQAQQAPAQAUAAQAVgBAQgQQARgQAAgYIAAgBQAAgZgRgPQgQgQgVAAQgVAAgPAPg");
	this.shape_198.setTransform(184.45,118.45);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_199.setTransform(739.475,86.025);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAARATQARAUAAAdIgBAFIhtAAQADAYAPAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_200.setTransform(723.95,86.175);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_201.setTransform(711.375,84.175);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_202.setTransform(698.425,83.3);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#FFFFFF").s().p("Ag7BFIAHgLQAZATAcAAQAYAAANgNQAPgOAAgZIAAgTQgVAfghAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAiAAAUAeIAAgbIANAAIAABvQAAAcgRARQgRASgfAAQghAAgbgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAUAAARgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgVAAgPAOg");
	this.shape_203.setTransform(681.35,88.125);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_204.setTransform(669.975,83.575);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_205.setTransform(662.325,86.071);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#FFFFFF").s().p("Ag0BBIAAAcIgNAAIAAi9IANAAIAABYQAVghAhAAQAZAAATASQAUATAAAfIAAAAQAAAfgUAUQgTASgZAAQghABgVgggAgkgNQgRAPAAAZIAAABQAAAYARAQQAPARAWgBQAVABAPgQQAPgPAAgaIAAgBQAAgZgPgQQgQgPgUAAQgWAAgPAQg");
	this.shape_206.setTransform(648.2,83.45);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#FFFFFF").s().p("AgLASQAOgIgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_207.setTransform(628.075,93.1);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_208.setTransform(618.25,86.175);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_209.setTransform(605.675,84.175);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_210.setTransform(592.825,86.225);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_211.setTransform(582.025,86.071);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#FFFFFF").s().p("AgsBOQgVgTAAgfIAAgBQAAgdAVgVQASgSAaAAQAgAAAVAgIAAhXIANAAIAAC9IgNAAIAAgdQgWAhgfgBQgaABgSgTgAgkgOQgPAPAAAaIAAAAQAAAaAPAQQAPAPAVAAQAWABAPgRQARgQAAgYIAAgBQAAgZgRgQQgPgPgWAAQgWAAgOAPg");
	this.shape_212.setTransform(567.05,83.45);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#FFFFFF").s().p("Ag9BSIAEgMQAKAGANgBQALABAHgIQAHgGAIgSIhAiCIAPAAIA2B1IAwh1IAOAAIg5CHQgJAVgKAJQgKAJgPgBQgNAAgNgFg");
	this.shape_213.setTransform(551.9,88.3);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_214.setTransform(536.875,83.3);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#FFFFFF").s().p("AgLASQAOgIgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_215.setTransform(517.675,93.1);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_216.setTransform(507.225,86.025);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_217.setTransform(495.925,83.575);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#FFFFFF").s().p("AApBfIg0hBIggAhIAAAgIgNAAIAAi9IANAAIAACNIBRhTIARAAIg5A5IA7BKg");
	this.shape_218.setTransform(486.225,83.3);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_219.setTransform(471.525,86.175);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_220.setTransform(445.175,86.025);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_221.setTransform(428.325,86.071);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_222.setTransform(419.125,83.575);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXAMgMQAJgKARAAQAMAAAIADIAAAMQgLgEgJAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_223.setTransform(411.7,83.275);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#FFFFFF").s().p("AgLASQAOgIgBgMIgGAAIAAgWIAQAAIAAATQAAAMgFAGQgFAIgKAEg");
	this.shape_224.setTransform(395.375,93.1);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_225.setTransform(386.125,86.175);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_226.setTransform(372.4,86.175);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_227.setTransform(356.875,86.025);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_228.setTransform(345.575,83.575);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#FFFFFF").s().p("AgFBfIAAi9IALAAIAAC9g");
	this.shape_229.setTransform(339.125,83.3);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_230.setTransform(320.65,86.175);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_231.setTransform(305.125,86.025);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_232.setTransform(293.825,83.575);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgUAAIAAgLIAUAAIAAgNQAAgXAMgMQAJgKASAAQAKAAAJADIAAAMQgKgEgJAAQgaAAAAAiIAAANIAtAAIAAALIgtAAIAAB4g");
	this.shape_233.setTransform(286.4,83.275);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_234.setTransform(265.575,83.3);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_235.setTransform(252.225,84.175);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_236.setTransform(238.825,86.175);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_237.setTransform(222.225,86.175);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_238.setTransform(201.625,86.025);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_239.setTransform(182.575,86.175);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_240.setTransform(736.325,51.175);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_241.setTransform(723.125,49.175);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#FFFFFF").s().p("AgFAnIADgiIgbATIgGgKIAegOIgegOIAGgJIAbASIgDghIALAAIgDAhIAbgSIAGAJIgeAOIAeAOIgGAKIgbgTIADAig");
	this.shape_242.setTransform(704.65,43.4);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#FFFFFF").s().p("AgFAnIADgiIgbATIgHgKIAfgOIgfgOIAHgJIAbASIgDghIALAAIgDAhIAbgSIAGAJIgeAOIAeAOIgGAKIgbgTIADAig");
	this.shape_243.setTransform(693.5,43.4);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_244.setTransform(681.275,51.175);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhuAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_245.setTransform(667.55,51.175);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#FFFFFF").s().p("AgtBPQgUgVAAgeIAAgBQAAgdAUgVQATgSAaAAQAhAAAUAgIAAhXIANAAIAAC9IgNAAIAAgdQgWAhgfAAQgaAAgTgSgAgkgOQgPAPAAAaIAAAAQAAAaAPAQQAPAPAVAAQAVABAQgRQARgQAAgYIAAgBQAAgZgRgQQgQgPgVAAQgVAAgPAPg");
	this.shape_246.setTransform(650.85,48.45);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_247.setTransform(639.475,48.575);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_248.setTransform(630.975,49.175);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#FFFFFF").s().p("AhBBYIAAitIANAAIAAAeQAVghAgABQAagBATATQAUATAAAfIAAAAQAAAfgUATQgTATgaAAQggAAgVgfIAABFgAgkg7QgRAQAAAYIAAABQAAAYARAQQAPAQAWAAQAWAAAOgPQAPgQAAgZIAAgBQAAgZgPgQQgQgQgUABQgWAAgPAQg");
	this.shape_249.setTransform(617.7,53.1);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_250.setTransform(601.25,51.175);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#FFFFFF").s().p("AhBBYIAAitIANAAIAAAeQAWghAfABQAagBATATQAUATAAAfIAAAAQAAAfgUATQgTATgaAAQggAAgVgfIAABFgAgkg7QgRAQAAAYIAAABQAAAYARAQQAPAQAWAAQAVAAAPgPQAPgQAAgZIAAgBQAAgZgQgQQgOgQgVABQgWAAgPAQg");
	this.shape_251.setTransform(585.4,53.1);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#FFFFFF").s().p("AgtBPQgUgVAAgeIAAgBQAAgdAUgVQATgSAZAAQAiAAAUAgIAAhXIANAAIAAC9IgNAAIAAgdQgVAhghAAQgZAAgTgSgAgkgOQgPAPAAAaIAAAAQAAAaAPAQQAPAPAVAAQAVABAQgRQARgQAAgYIAAgBQAAgZgRgQQgQgPgVAAQgWAAgOAPg");
	this.shape_252.setTransform(559.6,48.45);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_253.setTransform(543.625,51.025);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_254.setTransform(527.675,51.225);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f("#FFFFFF").s().p("AgEAnIACgiIgbATIgHgKIAfgOIgfgOIAHgJIAbASIgCghIAKAAIgDAhIAcgSIAFAJIgeAOIAeAOIgFAKIgcgTIADAig");
	this.shape_255.setTransform(507.3,43.4);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f("#FFFFFF").s().p("AgxAyIAIgLQAWASAYAAQAOAAAJgHQAJgHAAgLIAAgBQAAgKgLgHQgHgEgRgFQgVgGgJgFQgOgJAAgQIAAAAQAAgQAMgLQAMgKASAAQAZAAAWAPIgHAKQgUgNgUAAQgNAAgIAHQgJAGAAAKIAAABQAAAKAMAGQAHAEARAFQAVAGAJAFQAOAKAAAQIAAAAQAAARgNALQgNALgUAAQgdAAgYgTg");
	this.shape_256.setTransform(495.075,51.175);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_257.setTransform(484.375,51.071);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_258.setTransform(470.125,51.175);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_259.setTransform(456.925,49.175);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f("#FFFFFF").s().p("AgoAxQgUgUAAgdIAAAAQAAgbAUgVQAUgUAbAAQAdAAAYAYIgJAJQgWgWgWAAQgWAAgPARQgQARAAAXIAAAAQAAAYAQARQAQAQAWAAQAYAAAUgWIAJAIQgXAagfAAQgbAAgUgUg");
	this.shape_260.setTransform(444.575,51.175);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_261.setTransform(429.125,51.225);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f("#FFFFFF").s().p("AgTBfIAAh4IgTAAIAAgLIATAAIAAgNQAAgXALgMQAKgKARAAQALAAAKADIAAAMQgLgEgKAAQgaAAAAAiIAAANIAuAAIAAALIguAAIAAB4g");
	this.shape_262.setTransform(418.3,48.275);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f("#FFFFFF").s().p("AAsBfIAAhPQAAgTgLgNQgLgMgUAAQgSAAgOANQgNAOAAATIAABNIgNAAIAAi9IANAAIAABSQAQgbAfAAQAZAAAOAOQAOAPAAAYIAABRg");
	this.shape_263.setTransform(397.475,48.3);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_264.setTransform(384.125,49.175);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f("#FFFFFF").s().p("AAoBDIgohxIgnBxIgKAAIgxiFIAOAAIAoB0IAoh0IAKAAIAoB0IAoh0IANAAIgwCFg");
	this.shape_265.setTransform(367.825,51.2);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_266.setTransform(349.025,51.175);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_267.setTransform(336.925,51.071);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f("#FFFFFF").s().p("Ag7BFIAIgLQAYATAcAAQAYAAANgNQAPgOAAgZIAAgTQgWAfggAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAiAAAUAeIAAgbIANAAIAABvQAAAcgRARQgRASgfAAQggAAgcgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgWAAgOAOg");
	this.shape_268.setTransform(321.95,53.125);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAARATQAQAUAAAdIAAAFIhuAAQACAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgVAAQgTAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_269.setTransform(298.55,51.175);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_270.setTransform(287.075,51.071);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_271.setTransform(272.825,51.175);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_272.setTransform(252.225,51.025);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f("#FFFFFF").s().p("AAYBPQgLgNAAgTIAAAAQAAgUALgNQALgOASAAQARAAAMAOQALAOAAASIAAABQAAASgLAOQgMAOgSAAQgRAAgLgOgAAiAVQgIALAAAOIAAABQAAAOAIALQAIAKALAAQALAAAIgKQAHgKAAgPIAAAAQAAgPgIgLQgHgKgMAAQgLAAgHAKgAhJBbIBFhdIBAhYIAOAAIhGBdIg/BYgAhRgNQgLgOAAgSIAAgBQAAgTALgNQAMgOARAAQASAAALAOQALAOAAASIAAAAQAAAUgLANQgMANgRAAQgSAAgLgNgAhHhGQgHAJAAAPIAAAAQAAAQAIAKQAHAKALAAQAMAAAHgKQAIgLAAgOIAAgBQAAgPgIgKQgIgKgLAAQgLAAgIALg");
	this.shape_273.setTransform(221.325,48.7);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f("#FFFFFF").s().p("Ag2BCQgUgbAAgmIAAgBQAAgmAUgbQAWgcAgAAQAiAAAVAcQAUAbAAAmIAAAAQAAAngUAbQgWAcghAAQghAAgVgcgAgsg4QgQAYAAAgIAAAAQAAAhAQAYQASAZAaAAQAcAAARgZQAQgXAAghIAAgBQAAgggQgYQgSgZgbAAQgbAAgRAZg");
	this.shape_274.setTransform(201.375,48.7);

	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f("#FFFFFF").s().p("Ag+A8IAKgJQAXAdAhAAQATAAANgLQANgLAAgSIAAAAQAAgTgQgLQgPgKgZAAIgKAAIgDgHIA+hIIhfAAIAAgNIBxAAIAAAKIg8BHQAbABARALQATAOAAAYIAAABQAAAWgRAQQgSAPgYAAQgpAAgZghg");
	this.shape_275.setTransform(184,48.85);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f("#FFFFFF").s().p("Ag9BSIAEgLQALAEAMAAQALABAHgIQAIgGAHgSIhAiDIAPAAIA2B2IAwh2IAOAAIg5CIQgJAVgKAJQgKAJgPAAQgNgBgNgFg");
	this.shape_276.setTransform(747.3,18.3);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f("#FFFFFF").s().p("Ag0BBIAAAcIgNAAIAAi9IANAAIAABYQAVghAgAAQAaAAASASQAVAUAAAeIAAAAQAAAfgVAUQgSASgaABQggAAgVgggAgkgNQgRAQAAAYIAAAAQAAAZARARQAQAPAUAAQAXAAAOgOQAPgQAAgbIAAAAQAAgZgQgQQgOgPgWAAQgUAAgQAQg");
	this.shape_277.setTransform(732.2,13.45);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f("#FFFFFF").s().p("AgtBPQgUgVAAgfIAAAAQAAgdAUgVQATgSAZAAQAhAAAVAgIAAhXIANAAIAAC9IgNAAIAAgdQgVAhghAAQgZAAgTgSgAgkgOQgPAOAAAbIAAAAQAAAZAPARQAPAPAVAAQAVAAAQgPQARgRAAgZIAAAAQAAgZgRgQQgQgPgVAAQgWAAgOAPg");
	this.shape_278.setTransform(706.4,13.45);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_279.setTransform(690.8,16.175);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_280.setTransform(679.325,16.071);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAbAAARATQARAUAAAdIgBAFIhtAAQACAYAQAPQAOANAUAAQAaAAATgUIAJAHQgXAZggAAQgaAAgSgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgOAPgCAWIBgAAIAAAAg");
	this.shape_281.setTransform(665.9,16.175);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f("#FFFFFF").s().p("AAoBDIgohxIgnBxIgKAAIgxiFIAOAAIAoB0IAoh0IAKAAIAoB0IAoh0IANAAIgwCFg");
	this.shape_282.setTransform(647.675,16.2);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f("#FFFFFF").s().p("AgwAxQgTgUAAgdIAAAAQAAgbATgVQAUgUAcAAQAdAAAUAUQATAUAAAcIAAAAQAAAcgTAVQgUAUgdAAQgcAAgUgUgAgmgoQgPARAAAXIAAAAQAAAYAPARQAQAQAWAAQAYAAAPgQQAPgRAAgYIAAAAQAAgXgQgRQgPgRgXAAQgXAAgPARg");
	this.shape_283.setTransform(628.875,16.175);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f("#FFFFFF").s().p("AhBBYIAAitIANAAIAAAeQAWghAfABQAagBATATQAUATAAAfIAAAAQAAAfgUATQgTATgaAAQggAAgVgfIAABFgAgkg7QgRAQAAAYIAAABQAAAXARARQAPAQAWAAQAVAAAPgPQAPgPAAgaIAAgBQAAgYgQgRQgOgQgVAAQgWABgPAQg");
	this.shape_284.setTransform(612.4,18.1);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_285.setTransform(590.325,14.175);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_286.setTransform(577.375,16.025);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f("#FFFFFF").s().p("AgpAyQgUgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAaAAATgUIAJAHQgYAZgfAAQgaAAgSgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_287.setTransform(561.85,16.175);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f("#FFFFFF").s().p("ABYBEIAAhOQAAgVgLgMQgKgMgTAAQgRAAgMAMQgMANAAAWIAABMIgMAAIAAhPQAAgUgLgMQgKgMgSAAQgSAAgMANQgMAOAAAUIAABMIgNAAIAAiEIANAAIAAAYQAQgbAcAAQAfAAANAdQAQgdAfAAQAYAAAOAPQANAPAAAZIAABQg");
	this.shape_288.setTransform(541.875,16.025);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_289.setTransform(524.175,14.175);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_290.setTransform(511.325,16.225);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAQAPQAPANASAAQAbAAATgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_291.setTransform(496.85,16.175);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_292.setTransform(485.375,16.071);

	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f("#FFFFFF").s().p("AgIBQQgLgKAAgSIAAhWIgTAAIAAgLIATAAIAAgrIANAAIAAArIAtAAIAAALIgtAAIAABVQAAAaAZAAQAJAAALgFIAAAMQgKAFgMAAQgQAAgJgJg");
	this.shape_293.setTransform(474.125,14.175);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQASgUAaAAQAcAAAQATQARAUAAAdIgBAFIhsAAQACAYAPAPQAOANAUAAQAZAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgCgWgLgOQgNgQgWAAQgSAAgOAPQgOAPgBAWIBfAAIAAAAg");
	this.shape_294.setTransform(453.75,16.175);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f("#FFFFFF").s().p("Ag9BSIAFgLQAJAEANAAQAKABAIgIQAIgGAHgSIhAiDIAPAAIA2B2IAwh2IAOAAIg5CIQgJAVgKAJQgKAJgPAAQgNgBgNgFg");
	this.shape_295.setTransform(439.15,18.3);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f("#FFFFFF").s().p("AgqAyQgTgUAAgeIAAAAQAAgcASgUQATgUAZAAQAcAAAQATQARAUAAAdIAAAFIhtAAQABAYAPAPQAQANASAAQAaAAAUgUIAJAHQgYAZgfAAQgaAAgTgTgAAwgFQgBgWgMgOQgNgQgWAAQgSAAgOAPQgNAPgCAWIBfAAIAAAAg");
	this.shape_296.setTransform(424.75,16.175);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f("#FFFFFF").s().p("Ag7BFIAIgLQAYATAcAAQAYAAAOgNQAOgOAAgZIAAgTQgVAfghAAQgaAAgSgRQgUgSAAgaIAAgBQAAgcAUgSQASgRAaAAQAiAAAUAeIAAgbIANAAIAABvQAAAcgRARQgRASgfAAQggAAgcgUgAgkg+QgPAOAAAWIAAABQAAAWAQAOQAOAOAVAAQAVAAAQgOQARgOAAgWIAAAAQAAgWgRgPQgQgOgVAAQgVAAgPAOg");
	this.shape_297.setTransform(400.25,18.125);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_298.setTransform(384.275,16.025);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_299.setTransform(372.975,13.575);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_300.setTransform(361.925,16.025);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_301.setTransform(346.025,16.025);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f("#FFFFFF").s().p("AgFBcIAAiDIALAAIAACDgAgHhKIAAgRIAPAAIAAARg");
	this.shape_302.setTransform(334.725,13.575);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f("#FFFFFF").s().p("AAoBDIgohxIgnBxIgKAAIgxiFIAOAAIAoB0IAoh0IAKAAIAoB0IAoh0IANAAIgwCFg");
	this.shape_303.setTransform(320.325,16.2);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f("#FFFFFF").s().p("AgiAHIAAgNIBFAAIAAANg");
	this.shape_304.setTransform(303.85,15.075);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f("#FFFFFF").s().p("AgsBPQgVgVAAgfIAAAAQAAgdAVgVQASgSAaAAQAhAAAUAgIAAhXIANAAIAAC9IgNAAIAAgdQgWAhgfAAQgaAAgSgSgAgkgOQgPAOAAAbIAAAAQAAAZAQARQAPAPAUAAQAWAAAPgPQARgRAAgZIAAAAQAAgZgRgQQgPgPgWAAQgVAAgPAPg");
	this.shape_305.setTransform(289.55,13.45);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.f("#FFFFFF").s().p("AgjBDIAAiDIANAAIAAAlQAIgSAPgLQAQgLATABIAAAOIgBAAQgZAAgPARQgRASAAAeIAAA2g");
	this.shape_306.setTransform(277.625,16.071);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_307.setTransform(263.775,16.225);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.f("#FFFFFF").s().p("AAoBDIgohxIgnBxIgKAAIgxiFIAOAAIAoB0IAoh0IAKAAIAoB0IAoh0IANAAIgwCFg");
	this.shape_308.setTransform(246.075,16.2);

	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.f("#FFFFFF").s().p("AgoA6QgQgLAAgUIAAAAQAAgVAQgKQAQgLAZAAQAWAAAWAFIAAgFQAAgUgMgLQgLgKgVAAQgTAAgVALIgFgMQAZgLAVAAQAbAAAPAPQANANAAAYIAABSIgMAAIAAgWQgSAZggAAQgUAAgPgLgAgfAEQgLAIAAAOIAAABQAAANALAJQALAIAQAAQAUAAAOgLQAPgMAAgSIAAgPQgXgFgWAAQgTAAgMAIg");
	this.shape_309.setTransform(227.525,16.225);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.f("#FFFFFF").s().p("AAsBEIAAhOQAAgVgLgMQgLgMgUAAQgSAAgOANQgNAOAAAUIAABMIgNAAIAAiEIANAAIAAAZQAQgcAfAAQAZAAAOAPQAOAPAAAZIAABQg");
	this.shape_310.setTransform(204.875,16.025);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.f("#FFFFFF").s().p("ABMBcIgXgzIhqAAIgXAzIgOAAIBUi3IAMAAIBVC3gAAwAdIgwhpIgvBpIBfAAg");
	this.shape_311.setTransform(186.575,13.625);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294},{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266},{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mc_overlay_copy, new cjs.Rectangle(158.5,-93.9,642.8,417.1), null);


(lib.mc_overlay_award_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_254 = function() {
		stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(254).call(this.frame_254).wait(1));

	// award_product_card
	this.instance = new lib.mc_award_inStyle();
	this.instance.setTransform(732.2,90.5,0.3946,0.3946,0,0,0,182.6,182.5);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(74).to({_off:false},0).to({alpha:1},3).wait(178));

	// copy_layer
	this.copy_mc = new lib.mc_overlay_copy_2();
	this.copy_mc.name = "copy_mc";
	this.copy_mc.setTransform(42.15,284.8,1,1,0,0,0,145.5,148.5);
	this.copy_mc._off = true;

	this.timeline.addTween(cjs.Tween.get(this.copy_mc).wait(72).to({_off:false},0).wait(183));

	// overlay_navy
	this.instance_1 = new lib.Tween1("synched",0);
	this.instance_1.setTransform(425,239);
	this.instance_1._off = true;

	this.instance_2 = new lib.Tween2("synched",0);
	this.instance_2.setTransform(425,239);

	this.instance_3 = new lib.overlay_navy();
	this.instance_3.setTransform(425,240,1,1,0,0,0,425,240);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("A6KAKIAAgTMA0VAAAIAAAT");
	this.shape.setTransform(167.5,-0.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1}]},72).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.shape},{t:this.instance_3}]},177).to({state:[{t:this.shape},{t:this.instance_3}]},1).to({state:[{t:this.shape},{t:this.instance_3}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(72).to({_off:false},0).to({_off:true},3).wait(180));

	// product
	this.instance_4 = new lib.mc_product_9();
	this.instance_4.setTransform(-262.55,401.15,3.0936,3.0936,-18.0179,0,0,72.2,184.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({scaleX:3.0937,scaleY:3.0937,rotation:17.1737,x:464.15,y:213.2},7).to({scaleX:2.4346,scaleY:2.4346,rotation:-0.2984,x:626.3,y:123.55},7).to({rotation:-0.2984},60).to({_off:true},1).wait(180));

	// award
	this.instance_5 = new lib.mc_award_inStyle();
	this.instance_5.setTransform(243.5,238.5,1,1,0,0,0,182.5,182.5);
	this.instance_5.alpha = 0;
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(13).to({_off:false},0).to({alpha:1},10).wait(51).to({_off:true},1).wait(180));

	// smear
	this.instance_6 = new lib.mc_Lumiere_Firm_Riche_Smear();
	this.instance_6.setTransform(368.9,219.4,1.085,1.085,18.5832,0,0,499.9,499.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({regX:499.8,regY:499.9,scaleX:1.0847,scaleY:1.0847,rotation:5.0005,x:359.95,y:209.05},74).to({_off:true},1).wait(180));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-645.3,-467.3,1701.3999999999999,1388.3);


(lib.mc_overlay_award_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_254 = function() {
		stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(254).call(this.frame_254).wait(1));

	// award_product_card
	this.instance = new lib.mc_award_shape_skin();
	this.instance.setTransform(732.2,90.5,0.3946,0.3946,0,0,0,182.6,182.5);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(74).to({_off:false},0).to({alpha:1},3).wait(178));

	// copy_layer
	this.copy_mc = new lib.mc_overlay_copy();
	this.copy_mc.name = "copy_mc";
	this.copy_mc.setTransform(42.15,284.8,1,1,0,0,0,145.5,148.5);
	this.copy_mc._off = true;

	this.timeline.addTween(cjs.Tween.get(this.copy_mc).wait(72).to({_off:false},0).wait(183));

	// overlay_navy
	this.instance_1 = new lib.Tween1("synched",0);
	this.instance_1.setTransform(425,239);
	this.instance_1._off = true;

	this.instance_2 = new lib.Tween2("synched",0);
	this.instance_2.setTransform(425,239);

	this.instance_3 = new lib.overlay_navy();
	this.instance_3.setTransform(425,240,1,1,0,0,0,425,240);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("A6KAKIAAgTMA0VAAAIAAAT");
	this.shape.setTransform(167.5,-0.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1}]},72).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.shape},{t:this.instance_3}]},177).to({state:[{t:this.shape},{t:this.instance_3}]},1).to({state:[{t:this.shape},{t:this.instance_3}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(72).to({_off:false},0).to({_off:true},3).wait(180));

	// product
	this.instance_4 = new lib.mc_product_6_2();
	this.instance_4.setTransform(-262.55,401.15,3.0936,3.0936,-18.0179,0,0,72.2,184.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({scaleX:3.0937,scaleY:3.0937,rotation:17.1737,x:464.15,y:213.2},7).to({scaleX:2.4346,scaleY:2.4346,rotation:-0.2984,x:626.3,y:159.55},7).to({rotation:-0.2984},60).to({_off:true},1).wait(180));

	// award
	this.instance_5 = new lib.mc_award_shape_skin();
	this.instance_5.setTransform(243.5,238.5,1,1,0,0,0,182.5,182.5);
	this.instance_5.alpha = 0;
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(13).to({_off:false},0).to({alpha:1},10).wait(51).to({_off:true},1).wait(180));

	// smear
	this.instance_6 = new lib.mc_Lumiere_Firm_Smear();
	this.instance_6.setTransform(423.95,237,1,1,0,0,0,500,500);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({regX:499.9,regY:499.9,scaleX:1.0025,scaleY:0.9929,rotation:5.0006,x:386,y:255.1},74).to({_off:true},1).wait(180));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-648.1,-396,1576.8000000000002,1282.2);


// stage content:
(lib.neocutis1440x480right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0];
	// timeline functions:
	this.frame_0 = function() {
		var speed = 0.8;
		var tile = 1355.3; // start with +8px fudge
		
		createjs.Ticker.on("tick", function () {
		  var strip = this.mc_product_line; if (!strip) return;
		  strip.x -= speed;
		  if (strip.x <= -tile) strip.x += tile;
		}.bind(this));
		// --- AWARD OVERLAY ROTATOR (RIGHT) : start delay + gap between clips ---
		if (!this._awardInit) {
		  this._awardInit = true;
		
		  // Timing
		  var START_DELAY_MS = 2000;      // wait 2s before starting the first award
		  var GAP_MS = 2000;              // wait 2s after fade-out before next starts
		  var FADE_MS = 0;              // fade speed changed from 400 to 0 to eliminate the fade completely
		  var HOLD_AFTER_END_MS = 0;      // optional extra hold after clip ends (usually 0)
		
		  var a1 = this.mc_overlay_award_1;
		  var a2 = this.mc_overlay_award_2;
		
		  if (!a1 || !a2) {
		    console.warn("Missing mc_overlay_award_1 or mc_overlay_award_2 on stage.");
		    return;
		  }
		
		  // Ensure initial hidden state (we'll start after START_DELAY_MS)
		  a1.visible = false; a1.alpha = 0;
		  a2.visible = false; a2.alpha = 0;
		
		  var state = "START_DELAY"; // START_DELAY -> PLAYING -> GAP
		  var acc = 0;
		  var idx = 0; // 0=a1, 1=a2
		
		  function current() { return (idx === 0) ? a1 : a2; }
		  function other()   { return (idx === 0) ? a2 : a1; }
		
		  function startClip(mc) {
		    if (mc.gotoAndPlay) mc.gotoAndPlay(0);
		  }
		
		  function fadeIn(mc) {
		    createjs.Tween.removeTweens(mc);
		    mc.visible = true;
		    mc.alpha = 0;
		    createjs.Tween.get(mc).to({ alpha: 1 }, FADE_MS);
		  }
		
		  function fadeOut(mc) {
		    createjs.Tween.removeTweens(mc);
		    createjs.Tween.get(mc)
		      .to({ alpha: 0 }, FADE_MS)
		      .call(function () { mc.visible = false; });
		  }
		
		function beginCurrent() {
		  var mc = current();
		
		  startClip(mc);
		  fadeIn(mc);
		  state = "PLAYING";
		  acc = 0;
		}
		
		
		  function endAndGap() {
		    // Fade out the one that just finished
		    fadeOut(current());
		
		    // Toggle to next, but don't start it yet
		    idx = 1 - idx;
		
		    state = "GAP";
		    acc = 0;
		  }
		
		  // IMPORTANT:
		  // Put `stop();` on the LAST frame of BOTH award clips
		  // so they stop on their end frame.
		
		  createjs.Ticker.on("tick", function (evt) {
		    var dt = evt.delta || 0;
		    acc += dt;
		
		    if (state === "START_DELAY") {
		      if (acc >= START_DELAY_MS) beginCurrent();
		      return;
		    }
		
		    if (state === "PLAYING") {
		      var mc = current();
		      if (!mc) return;
		
		      // when clip reaches end (and is stopped there), wait optional hold then end
		      if (mc.currentFrame >= (mc.totalFrames - 1)) {
		        if (acc >= HOLD_AFTER_END_MS) endAndGap();
		      }
		      return;
		    }
		
		    if (state === "GAP") {
		      if (acc >= GAP_MS) beginCurrent();
		      return;
		    }
		  });
		}
		this.stage.enableMouseOver(20);
		this.stage.mouseMoveOutside = true;
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(450));

	// overlay_award_2
	this.mc_overlay_award_2 = new lib.mc_overlay_award_2();
	this.mc_overlay_award_2.name = "mc_overlay_award_2";
	this.mc_overlay_award_2.setTransform(424.8,237.85,1,0.996,0,0,0,424.8,238.8);
	this.mc_overlay_award_2.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.mc_overlay_award_2).wait(450));

	// overlay_award_1
	this.mc_overlay_award_1 = new lib.mc_overlay_award_1();
	this.mc_overlay_award_1.name = "mc_overlay_award_1";
	this.mc_overlay_award_1.setTransform(136.4,374.1,1,1,0,0,0,136.4,374.1);
	this.mc_overlay_award_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.mc_overlay_award_1).wait(450));

	// product_line
	this.mc_product_line = new lib.mc_product_line();
	this.mc_product_line.name = "mc_product_line";
	this.mc_product_line.setTransform(414.5,55,1,1,0,0,0,414.5,55);

	this.timeline.addTween(cjs.Tween.get(this.mc_product_line).wait(450));

	// shadow
	this.instance = new lib.mc_shadow();
	this.instance.setTransform(443.5,250,1,1,0,0,0,443.5,250);
	this.instance.compositeOperation = "multiply";

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:443.7,regY:249.8,scaleX:1.3635,scaleY:2.3322,rotation:44.9997,x:446.5,y:247.4,alpha:0.9805},449).wait(1));

	// background
	this.instance_1 = new lib.bkgnd_black_friday();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(450));

	// stageBackground
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1,3,true).p("EhD9gnDMCH7AAAMAAABOHMiH7AAAg");
	this.shape.setTransform(425,240);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EhD9AnEMAAAhOHMCH7AAAMAAABOHg");
	this.shape_1.setTransform(425,240);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(450));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-223.1,-352.3,2926.1,1439.7);
// library properties:
lib.properties = {
	id: 'BF1AB29EBFDE460099CCABE88E1B5420',
	width: 850,
	height: 480,
	fps: 15,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"images/award_instyle_2025.png?1771257257620", id:"award_instyle_2025"},
		{src:"images/award_shape_2025.png?1771257257620", id:"award_shape_2025"},
		{src:"images/BBCA_NEO_Aftercare_30ml_Cap.png?1771257257620", id:"BBCA_NEO_Aftercare_30ml_Cap"},
		{src:"images/BBCA_NEO_BioCream_FirmRiche_15ml_Cap.png?1771257257620", id:"BBCA_NEO_BioCream_FirmRiche_15ml_Cap"},
		{src:"images/BBCA_NEO_BioGel_Firm_15ml_Cap.png?1771257257620", id:"BBCA_NEO_BioGel_Firm_15ml_Cap"},
		{src:"images/BBCA_NEO_BioSerum_Firm_30ml_Cap.png?1771257257620", id:"BBCA_NEO_BioSerum_Firm_30ml_Cap"},
		{src:"images/BBCA_NEO_Lumiere_Firm_15ml_Cap.png?1771257257620", id:"BBCA_NEO_Lumiere_Firm_15ml_Cap"},
		{src:"images/BBCA_NEO_Lumiere_Firm_15ml_Cap_NoReflection.png?1771257257620", id:"BBCA_NEO_Lumiere_Firm_15ml_Cap_NoReflection"},
		{src:"images/BBCA_NEO_Lumiere_FirmRiche_15ml_Cap_NoReflection.png?1771257257620", id:"BBCA_NEO_Lumiere_FirmRiche_15ml_Cap_NoReflection"},
		{src:"images/BBCA_NEO_NeoFirm_Cap.png?1771257257620", id:"BBCA_NEO_NeoFirm_Cap"},
		{src:"images/BBCA_NEO_NeoTherapy_Cap.png?1771257257620", id:"BBCA_NEO_NeoTherapy_Cap"},
		{src:"images/BBCA_NEO_Reactive_30ml_Cap.png?1771257257620", id:"BBCA_NEO_Reactive_30ml_Cap"},
		{src:"images/bkgnd_black_friday.png?1771257257620", id:"bkgnd_black_friday"},
		{src:"images/countertop_black_friday.png?1771257257620", id:"countertop_black_friday"},
		{src:"images/fr1BBCA_NEO_Lumiere_Firm_15mlsmear.jpg?1771257257620", id:"fr1BBCA_NEO_Lumiere_Firm_15mlsmear"},
		{src:"images/fr1BBCA_NEO_Lumiere_Firm_Riche_15mlsmear.jpg?1771257257620", id:"fr1BBCA_NEO_Lumiere_Firm_Riche_15mlsmear"},
		{src:"images/shadow_blackfriday.png?1771257257620", id:"shadow_blackfriday"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['BF1AB29EBFDE460099CCABE88E1B5420'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;